/* eslint-disable */
/**
 * This file was automatically generated by @algorandfoundation/algokit-client-generator.
 * DO NOT MODIFY IT BY HAND.
 * requires: @algorandfoundation/algokit-utils: ^7
 */
import { AlgorandClientInterface } from '@algorandfoundation/algokit-utils/types/algorand-client-interface'
import { ABIReturn, AppReturn, SendAppTransactionResult } from '@algorandfoundation/algokit-utils/types/app'
import { Arc56Contract, getArc56ReturnValue, getABIStructFromABITuple } from '@algorandfoundation/algokit-utils/types/app-arc56'
import {
  AppClient as _AppClient,
  AppClientMethodCallParams,
  AppClientParams,
  AppClientBareCallParams,
  CallOnComplete,
  AppClientCompilationParams,
  ResolveAppClientByCreatorAndName,
  ResolveAppClientByNetwork,
  CloneAppClientParams,
} from '@algorandfoundation/algokit-utils/types/app-client'
import { AppFactory as _AppFactory, AppFactoryAppClientParams, AppFactoryResolveAppClientByCreatorAndNameParams, AppFactoryDeployParams, AppFactoryParams, CreateSchema } from '@algorandfoundation/algokit-utils/types/app-factory'
import { TransactionComposer, AppCallMethodCall, AppMethodCallTransactionArgument, SimulateOptions, RawSimulateOptions, SkipSignaturesSimulateOptions } from '@algorandfoundation/algokit-utils/types/composer'
import { SendParams, SendSingleTransactionResult, SendAtomicTransactionComposerResults } from '@algorandfoundation/algokit-utils/types/transaction'
import { Address, encodeAddress, modelsv2, OnApplicationComplete, Transaction, TransactionSigner } from 'algosdk'
import SimulateResponse = modelsv2.SimulateResponse

export const APP_SPEC: Arc56Contract = {"name":"NFDRegistry","desc":"","methods":[{"name":"updateApplication","args":[],"returns":{"type":"void"},"actions":{"create":[],"call":["UpdateApplication"]}},{"name":"gas","args":[],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"getPrice","desc":"Returns the price for a given NFD (single year), the max # of years allowed (Name for Display),\nand extra algo required to cover MBR when purchasing.","args":[{"name":"nfdName","type":"string","desc":"The NFD name for which to retrieve the price."},{"name":"caller","type":"address","desc":"the address this request is on behalf of (since an nfd contract might call us it\nneeds to be able to pass on the request on behalf of ITS caller - ie: getting price for an expired nfd will be\ndifferent if its owner ir asking.\n PriceInfo Type containing the price, carry cost, etc."}],"returns":{"type":"(uint64,uint64,bool,bool,bool)","struct":"PriceInfo"},"actions":{"create":[],"call":["NoOp"]}},{"name":"getConstraints","args":[],"returns":{"type":"(uint64,uint64,uint64,address,uint64,uint64,uint64)","struct":"Constraints"},"actions":{"create":[],"call":["NoOp"]}},{"name":"getNfdMbrCost","desc":"Returns the MBR amounts needed to MINT an nfd.\nThis value needs to be added to purchase price in mintNfd call.\ngetPrice() returns it though.","args":[{"name":"nfdName","type":"string"}],"returns":{"type":"uint64"},"actions":{"create":[],"call":["NoOp"]}},{"name":"getNfdLinkOnMintExtraMbrCost","args":[{"name":"address","type":"address"}],"returns":{"type":"(uint64,uint64)","struct":"LinkOnMintExtraMbrCosts"},"actions":{"create":[],"call":["NoOp"]}},{"name":"mintNfd","desc":"Mint an NFD (NFT) and create a new NFD instance.","args":[{"name":"purchaseTxn","type":"pay","desc":"The payment transaction covering the purchase amount of the nfd"},{"name":"nfdName","type":"string","desc":"The name of the NFD to mint"},{"name":"reservedFor","type":"address","desc":"The address that will own the NFD once minted (so you can buy for someone else)"},{"name":"linkOnMint","type":"bool","desc":"whether to auto-link the address (reserved for MUST MATCH payer!) at mint\n uint64 - The ID of the newly created NFD instance."}],"returns":{"type":"uint64"},"events":[{"name":"nfdRegistry_minted","args":[{"name":"appId","type":"uint64"},{"name":"name","type":"string"},{"name":"priceOneYear","type":"uint64"},{"name":"paidAmount","type":"uint64"},{"name":"carryCost","type":"uint64"},{"name":"seller","type":"address"},{"name":"buyer","type":"address"},{"name":"owner","type":"address"},{"name":"expTime","type":"uint64"},{"name":"amountToSeller","type":"uint64"},{"name":"commissionAddress","type":"address"},{"name":"amountToCommission","type":"uint64"},{"name":"segmentRootOwner","type":"address"},{"name":"amountToSegmentRoot","type":"uint64"}],"desc":""}],"actions":{"create":[],"call":["NoOp"]}},{"name":"linkNfdAddress","args":[{"name":"nfdName","type":"string"},{"name":"nfdAppId","type":"uint64"},{"name":"addrToVerify","type":"address"}],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"unlinkNfdAddress","args":[{"name":"nfdName","type":"string"},{"name":"nfdAppId","type":"uint64"},{"name":"addrToUnlink","type":"address"}],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"ownershipAssign","args":[{"name":"nfdName","type":"string"},{"name":"nfdAppId","type":"uint64"}],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"ownershipChanged","desc":"This method is triggered when the ownership of an NFD (Non-Fungible Domain) changes.\nIt is called by the NFD via the purchase method.  It can also be called by TxnLab admin for older 3.3\nNFDs when it detects purchased events for 3.3","args":[{"name":"nfdName","type":"string","desc":"The name of the NFD."},{"name":"nfdAppId","type":"uint64","desc":"The unique application ID of the NFD."},{"name":"seller","type":"address","desc":"The address of the prior owner (seller) of the nfd"},{"name":"buyer","type":"address","desc":"The address of the new owner of the NFD."}],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"setAddressPrimaryNfd","desc":"Makes the specified NFD the 'first' NFD in the reverse-address set so its the primary NFD for this address.\nThe NFD must be valid, and the sender must be the address (or nfd owner if vault).  The NFD wouldn't already be\nin the reverse-lookup set if it wasn't already valid.","args":[{"name":"nfdName","type":"string"},{"name":"nfdAppId","type":"uint64"},{"name":"addrBeingModified","type":"address"}],"returns":{"type":"void"},"events":[{"name":"nfdRegistry_addressPrimaryNfdChanged","args":[{"name":"appId","type":"uint64"},{"name":"name","type":"string"},{"name":"address","type":"address"}],"desc":""}],"actions":{"create":[],"call":["NoOp"]}},{"name":"upgradeNfd","args":[{"name":"nfdName","type":"string"}],"returns":{"type":"string"},"actions":{"create":[],"call":["NoOp"]}},{"name":"isValidNfdAppId","args":[{"name":"nfdName","type":"string"},{"name":"nfdAppId","type":"uint64"}],"returns":{"type":"bool"},"actions":{"create":[],"call":["NoOp"]}},{"name":"getNameAppId","args":[{"name":"nfdName","type":"string"}],"returns":{"type":"uint64"},"actions":{"create":[],"call":["NoOp"]}},{"name":"getAddressAppIds","args":[{"name":"lookupAddress","type":"address"}],"returns":{"type":"uint64[]"},"actions":{"create":[],"call":["NoOp"]}},{"name":"nfdContractInit","desc":"Initializes the NFD contract bytecode into the registry","args":[{"name":"version","type":"string","desc":"The version of the contract."},{"name":"size","type":"uint64","desc":"exact byte size of contract to load"},{"name":"clearCode","type":"byte[]","desc":"bytes of clear code"}],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"nfdContractLoad","desc":"Loads contract data into the  box at the specified offset.","args":[{"name":"version","type":"string","desc":"The version of the contract."},{"name":"offset","type":"uint64","desc":"The offset at which to replace the contract data within the box."},{"name":"data","type":"byte[]","desc":"The contract data to be loaded."}],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"nfdContractCommit","desc":"Commit a new version of the contract.","args":[{"name":"version","type":"string","desc":"The version number of the contract to be committed."}],"returns":{"type":"void"},"actions":{"create":[],"call":["NoOp"]}},{"name":"usdInMicroAlgo","args":[{"name":"usdCost","type":"uint64"}],"returns":{"type":"uint64"},"actions":{"create":[],"call":["NoOp"]}},{"name":"costToAddToAddress","desc":"Returns the cost to add an NFD to the reverse-lookup data","args":[{"name":"lookupAddress","type":"address","desc":"The address to add the NFD app id to"}],"returns":{"type":"uint64"},"actions":{"create":[],"call":["NoOp"]}},{"name":"calcFuturePrice","desc":"Calculates the future price based on the current price and the number of years.","args":[{"name":"curPrice","type":"uint64","desc":"The current price in USD (in decimals). For example, if the current price is $2.00, the value should be 200."},{"name":"forTime","type":"uint64","desc":"The timestamp to calc the future price based on - ie: 1 year past 'go live date' the price would have inflated by 1 year.\n\n\n uint64 The future price calculated based on the current price and the specified number of years."}],"returns":{"type":"uint64"},"actions":{"create":[],"call":["NoOp"]}},{"name":"createApplication","args":[],"returns":{"type":"void"},"actions":{"create":["NoOp"],"call":[]}}],"events":[{"name":"nfdRegistry_minted","args":[{"name":"appId","type":"uint64"},{"name":"name","type":"string"},{"name":"priceOneYear","type":"uint64"},{"name":"paidAmount","type":"uint64"},{"name":"carryCost","type":"uint64"},{"name":"seller","type":"address"},{"name":"buyer","type":"address"},{"name":"owner","type":"address"},{"name":"expTime","type":"uint64"},{"name":"amountToSeller","type":"uint64"},{"name":"commissionAddress","type":"address"},{"name":"amountToCommission","type":"uint64"},{"name":"segmentRootOwner","type":"address"},{"name":"amountToSegmentRoot","type":"uint64"}],"desc":""},{"name":"nfdRegistry_addressPrimaryNfdChanged","args":[{"name":"appId","type":"uint64"},{"name":"name","type":"string"},{"name":"address","type":"address"}],"desc":""}],"arcs":[4,56],"structs":{"PriceInfo":[{"name":"oneYearPrice","type":"uint64"},{"name":"carryCost","type":"uint64"},{"name":"exists","type":"bool"},{"name":"isExpired","type":"bool"},{"name":"inAuction","type":"bool"}],"Constraints":[{"name":"segmentPlatformCostInUsd","type":"uint64"},{"name":"segmentPlatformCostInAlgo","type":"uint64"},{"name":"maxYearsAllowed","type":"uint64"},{"name":"treasuryAddress","type":"address"},{"name":"expiredAuctionDuration","type":"uint64"},{"name":"expiredStartingPrice","type":"uint64"},{"name":"maxMintCarryCost","type":"uint64"}],"LinkOnMintExtraMbrCosts":[{"name":"linkingNfdMbrCost","type":"uint64"},{"name":"linkingRegistryMbrCost","type":"uint64"}]},"state":{"schema":{"global":{"bytes":0,"ints":0},"local":{"bytes":16,"ints":0}},"keys":{"global":{},"local":{},"box":{}},"maps":{"global":{},"local":{"localState":{"keyType":"AVMBytes","valueType":"AVMBytes"}},"box":{"boxes":{"keyType":"AVMBytes","valueType":"AVMBytes"}}}},"bareActions":{"create":[],"call":[]},"sourceInfo":{"approval":{"sourceInfo":[{"teal":25,"source":"contracts/NFDRegistry.algo.ts:51","errorMessage":"The requested action is not implemented in this contract. Are you using the correct OnComplete? Did you set your app ID?","pc":[35]},{"teal":414,"source":"contracts/NFDRegistry.algo.ts:179","errorMessage":"invalid","pc":[516]},{"teal":510,"source":"contracts/NFDRegistry.algo.ts:198","errorMessage":"invalid method","pc":[637]},{"teal":514,"source":"contracts/NFDRegistry.algo.ts:200","errorMessage":"unknown method","pc":[638]},{"teal":542,"source":"contracts/NFDRegistry.algo.ts:216","errorMessage":"argument 0 (caller) for getPrice must be a address","pc":[658]},{"teal":736,"source":"contracts/NFDRegistry.algo.ts:256","errorMessage":"argument 0 (address) for getNfdLinkOnMintExtraMbrCost must be a address","pc":[909]},{"teal":780,"source":"contracts/NFDRegistry.algo.ts:272","errorMessage":"argument 0 (linkOnMint) for mintNfd must be a bool","pc":[947]},{"teal":792,"source":"contracts/NFDRegistry.algo.ts:272","errorMessage":"argument 1 (reservedFor) for mintNfd must be a address","pc":[958]},{"teal":808,"source":"contracts/NFDRegistry.algo.ts:272","errorMessage":"argument 3 (purchaseTxn) for mintNfd must be a pay transaction","pc":[974]},{"teal":843,"source":"contracts/NFDRegistry.algo.ts:273","errorMessage":"transaction verification failed: {\"txn\":\"purchaseTxn\",\"field\":\"receiver\",\"expected\":\"this.app.address\"}","pc":[996]},{"teal":931,"source":"contracts/NFDRegistry.algo.ts:290","errorMessage":"parent nfd/id must be found","pc":[1085]},{"teal":951,"source":"contracts/NFDRegistry.algo.ts:294","errorMessage":"global state value does not exist: AppID.fromUint64(parentAppId).globalState(NFD_KEY_SELLER)","pc":[1114]},{"teal":968,"source":"contracts/NFDRegistry.algo.ts:298","errorMessage":"global state value does not exist: AppID.fromUint64(parentAppId).globalState(NFD_KEY_OWNER)","pc":[1128]},{"teal":972,"source":"contracts/NFDRegistry.algo.ts:297","errorMessage":"only owner of root can mint segments if segments are locked","pc":[1130]},{"teal":996,"source":"contracts/NFDRegistry.algo.ts:306","errorMessage":"price can never be 0","pc":[1154]},{"teal":1052,"source":"contracts/NFDRegistry.algo.ts:315","errorMessage":"if linking on mint, the buyer MUST be who will be the owner (reservedFor)","pc":[1208]},{"teal":1081,"source":"contracts/NFDRegistry.algo.ts:322","errorMessage":"payment transaction must be at least enough to cover 30 days of nfd cost + carry cost","pc":[1232]},{"teal":1090,"source":"contracts/NFDRegistry.algo.ts:330","errorMessage":"box value does not exist: this.boxes(REGISTRY_CONTRACT_BOX_CURRENT_CONTRACT).value","pc":[1236]},{"teal":1103,"source":"contracts/NFDRegistry.algo.ts:333","errorMessage":"box value does not exist: this.boxes(REGISTRY_CONTRACT_BOX_CURRENT_CONTRACT).value","pc":[1244]},{"teal":1115,"source":"contracts/NFDRegistry.algo.ts:335","errorMessage":"box value does not exist: this.boxes(concat(REGISTRY_CONTRACT_BOX_CLEAR_NAMEPREFIX, currentContractVer)).value","pc":[1254]},{"teal":1124,"source":"contracts/NFDRegistry.algo.ts:336","errorMessage":"box value does not exist: this.boxes(approvProgName).size","pc":[1260]},{"teal":1470,"source":"contracts/NFDRegistry.algo.ts:425","errorMessage":"global state value does not exist: AppID.fromUint64(parentAppId).globalState(NFD_KEY_VERSION)","pc":[1602]},{"teal":1475,"source":"contracts/NFDRegistry.algo.ts:424","errorMessage":"nfd root not 3.x must be version 2.12 in order for segment minting to succeed","pc":[1610]},{"teal":1768,"source":"contracts/NFDRegistry.algo.ts:479","errorMessage":"argument 0 (addrToVerify) for linkNfdAddress must be a address","pc":[1967]},{"teal":1804,"source":"contracts/NFDRegistry.algo.ts:481","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_OWNER)","pc":[1999]},{"teal":1814,"source":"contracts/NFDRegistry.algo.ts:483","errorMessage":"referenced NFD name/id must be valid","pc":[2009]},{"teal":1834,"source":"contracts/NFDRegistry.algo.ts:489","errorMessage":"verifying vault account, sender must be NFD owner","pc":[2026]},{"teal":1845,"source":"contracts/NFDRegistry.algo.ts:492","errorMessage":"app call sender must match address being added/removed","pc":[2035]},{"teal":1859,"source":"contracts/NFDRegistry.algo.ts:495","errorMessage":"nfd verified caAlgo.0.as must contain address being added/removed","pc":[2045]},{"teal":1878,"source":"contracts/NFDRegistry.algo.ts:510","errorMessage":"should add nfd to reverse address","pc":[2064]},{"teal":1899,"source":"contracts/NFDRegistry.algo.ts:520","errorMessage":"argument 0 (addrToUnlink) for unlinkNfdAddress must be a address","pc":[2083]},{"teal":1929,"source":"contracts/NFDRegistry.algo.ts:521","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_OWNER)","pc":[2108]},{"teal":1939,"source":"contracts/NFDRegistry.algo.ts:523","errorMessage":"referenced NFD name/id must be valid","pc":[2118]},{"teal":1969,"source":"contracts/NFDRegistry.algo.ts:529","errorMessage":"Sender unlinking must be NFD owner OR address removing itself","pc":[2148]},{"teal":1983,"source":"contracts/NFDRegistry.algo.ts:534","errorMessage":"nfd verified caAlgo.0.as must contain address being removed","pc":[2158]},{"teal":2085,"source":"contracts/NFDRegistry.algo.ts:558","errorMessage":"referenced NFD name/id must be valid","pc":[2257]},{"teal":2098,"source":"contracts/NFDRegistry.algo.ts:560","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_OWNER)","pc":[2264]},{"teal":2128,"source":"contracts/NFDRegistry.algo.ts:579","errorMessage":"argument 0 (buyer) for ownershipChanged must be a address","pc":[2291]},{"teal":2138,"source":"contracts/NFDRegistry.algo.ts:579","errorMessage":"argument 1 (seller) for ownershipChanged must be a address","pc":[2300]},{"teal":2191,"source":"contracts/NFDRegistry.algo.ts:583","errorMessage":"referenced NFD name/id must be valid","pc":[2337]},{"teal":2201,"source":"contracts/NFDRegistry.algo.ts:584","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_VERSION)","pc":[2343]},{"teal":2216,"source":"contracts/NFDRegistry.algo.ts:586","errorMessage":"only txnlab can call this method to backfill ownership, 3.4+ handles it by calling from the nfd itself","pc":[2358]},{"teal":2266,"source":"contracts/NFDRegistry.algo.ts:609","errorMessage":"argument 0 (addrBeingModified) for setAddressPrimaryNfd must be a address","pc":[2406]},{"teal":2302,"source":"contracts/NFDRegistry.algo.ts:610","errorMessage":"referenced NFD name/id must be valid","pc":[2433]},{"teal":2311,"source":"contracts/NFDRegistry.algo.ts:611","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_OWNER)","pc":[2438]},{"teal":2332,"source":"contracts/NFDRegistry.algo.ts:617","errorMessage":"if changing primary nfd for vault account, sender must be NFD owner","pc":[2457]},{"teal":2346,"source":"contracts/NFDRegistry.algo.ts:620","errorMessage":"app call sender must match address being updated to change primary NFD","pc":[2466]},{"teal":2428,"source":"contracts/NFDRegistry.algo.ts:641","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_OWNER)","pc":[2558]},{"teal":2438,"source":"contracts/NFDRegistry.algo.ts:642","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_NAME)","pc":[2566]},{"teal":2459,"source":"contracts/NFDRegistry.algo.ts:643","errorMessage":"only NFD owner or TxnLab can upgrade NFD","pc":[2586]},{"teal":2476,"source":"contracts/NFDRegistry.algo.ts:652","errorMessage":"box value does not exist: this.boxes(REGISTRY_CONTRACT_BOX_CURRENT_CONTRACT).value","pc":[2598]},{"teal":2489,"source":"contracts/NFDRegistry.algo.ts:654","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_VERSION)","pc":[2606]},{"teal":2494,"source":"contracts/NFDRegistry.algo.ts:653","errorMessage":"contract already at this version","pc":[2610]},{"teal":2506,"source":"contracts/NFDRegistry.algo.ts:659","errorMessage":"box value does not exist: this.boxes(REGISTRY_CONTRACT_BOX_CURRENT_CONTRACT).value","pc":[2616]},{"teal":2518,"source":"contracts/NFDRegistry.algo.ts:661","errorMessage":"box value does not exist: this.boxes(concat(REGISTRY_CONTRACT_BOX_CLEAR_NAMEPREFIX, currentContractVer)).value","pc":[2626]},{"teal":2527,"source":"contracts/NFDRegistry.algo.ts:662","errorMessage":"box value does not exist: this.boxes(approvProgName).size","pc":[2632]},{"teal":2730,"source":"contracts/NFDRegistry.algo.ts:697","errorMessage":"box value does not exist: this.boxes(boxName).value","pc":[2809]},{"teal":2768,"source":"contracts/NFDRegistry.algo.ts:702","errorMessage":"argument 0 (lookupAddress) for getAddressAppIds must be a address","pc":[2837]},{"teal":2827,"source":"contracts/NFDRegistry.algo.ts:708","errorMessage":"box value does not exist: this.boxes(boxName).value","pc":[2888]},{"teal":3056,"source":"contracts/NFDRegistry.algo.ts:758","errorMessage":"global state value does not exist: AppID.fromUint64(this.algoUsdOracleAppId).globalState('ts')","pc":[3084]},{"teal":3066,"source":"contracts/NFDRegistry.algo.ts:759","errorMessage":"global state value does not exist: AppID.fromUint64(this.algoUsdOracleAppId).globalState('decimals')","pc":[3100]},{"teal":3076,"source":"contracts/NFDRegistry.algo.ts:760","errorMessage":"global state value does not exist: AppID.fromUint64(this.algoUsdOracleAppId).globalState('price')","pc":[3113]},{"teal":3141,"source":"contracts/NFDRegistry.algo.ts:777","errorMessage":"argument 0 (lookupAddress) for costToAddToAddress must be a address","pc":[3195]},{"teal":3383,"source":"contracts/NFDRegistry.algo.ts:847","errorMessage":"box value does not exist: this.boxes(key).value","pc":[3429]},{"teal":3494,"source":"contracts/NFDRegistry.algo.ts:864","errorMessage":"box value does not exist: this.boxes(key).value","pc":[3516]},{"teal":3900,"source":"contracts/NFDRegistry.algo.ts:965","errorMessage":"box value does not exist: this.boxes(boxName).value","pc":[3918]},{"teal":3922,"source":"contracts/NFDRegistry.algo.ts:974","errorMessage":"must be existing v1 name","pc":[3935]},{"teal":3932,"source":"contracts/NFDRegistry.algo.ts:979","errorMessage":"global state value does not exist: AppID.fromUint64(btoi(this.txn.applicationArgs![2])).globalState(REGISTRY_KEY_ASAID)","pc":[3950]},{"teal":4106,"source":"contracts/NFDRegistry.algo.ts:1032","errorMessage":"NFD already exists with this name","pc":[4102]},{"teal":4134,"source":"contracts/NFDRegistry.algo.ts:1038","errorMessage":"NFD has already been minted!","pc":[4122]},{"teal":4206,"source":"contracts/NFDRegistry.algo.ts:1055","errorMessage":"box value does not exist: this.boxes(key).value","pc":[4184]},{"teal":4224,"source":"contracts/NFDRegistry.algo.ts:1059","errorMessage":"int (appid) 'set' should already have at least two values","pc":[4198]},{"teal":4307,"source":"contracts/NFDRegistry.algo.ts:1073","errorMessage":"int (app id) must be found in set in order to move it","pc":[4267]},{"teal":4363,"source":"contracts/NFDRegistry.algo.ts:1084","errorMessage":"box value does not exist: this.boxes(key).value","pc":[4311]},{"teal":4742,"source":"contracts/NFDRegistry.algo.ts:1166","errorMessage":"if not at least 6 chars can't be valid - minimum length to have .algo","pc":[4637]},{"teal":4756,"source":"contracts/NFDRegistry.algo.ts:1167","errorMessage":"string must end w/ .algo","pc":[4656]},{"teal":4851,"source":"contracts/NFDRegistry.algo.ts:1182","errorMessage":"must be 1-27 chars in nfd root or segment name","pc":[4739]},{"teal":4895,"source":"contracts/NFDRegistry.algo.ts:1185","errorMessage":"must be 1-27 chars and at end of string","pc":[4781]},{"teal":4900,"source":"contracts/NFDRegistry.algo.ts:1190","errorMessage":"too many '.' chars in name","pc":[4785]},{"teal":4949,"source":"contracts/NFDRegistry.algo.ts:1198","errorMessage":"invalid character in name","pc":[4836]},{"teal":5089,"source":"contracts/NFDRegistry.algo.ts:1219","errorMessage":"box value does not exist: this.boxes(boxName).value","pc":[4971]},{"teal":5160,"source":"contracts/NFDRegistry.algo.ts:1232","errorMessage":"global state value does not exist: AppID.fromUint64(appId).globalState(key)","pc":[5031]},{"teal":5192,"source":"contracts/NFDRegistry.algo.ts:1239","errorMessage":"global state value does not exist: AppID.fromUint64(appId).globalState(key)","pc":[5054]},{"teal":5258,"source":"contracts/NFDRegistry.algo.ts:1272","errorMessage":"parent nfd/id must be found","pc":[5095]},{"teal":5325,"source":"contracts/NFDRegistry.algo.ts:1287","errorMessage":"segment mint cost must be at least NFD_MIN_SEGMENT_USD","pc":[5178]},{"teal":5426,"source":"contracts/NFDRegistry.algo.ts:1309","errorMessage":"invalid cost calc","pc":[5284]},{"teal":5476,"source":"contracts/NFDRegistry.algo.ts:1320","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_OWNER)","pc":[5327]},{"teal":5633,"source":"contracts/NFDRegistry.algo.ts:1351","errorMessage":"price always needs to be at least 1 algo","pc":[5480]},{"teal":6086,"source":"contracts/NFDRegistry.algo.ts:1456","errorMessage":"lsig has to have i.appid localstate","pc":[5951]},{"teal":6159,"source":"contracts/NFDRegistry.algo.ts:1479","errorMessage":"box value does not exist: this.boxes(boxName).value","pc":[6024]},{"teal":6168,"source":"contracts/NFDRegistry.algo.ts:1480","errorMessage":"box value does not exist: this.boxes(boxName).size","pc":[6030]},{"teal":6227,"source":"contracts/NFDRegistry.algo.ts:1487","errorMessage":"global state value does not exist: AppID.fromUint64(nfdAppId).globalState(NFD_KEY_NAME)","pc":[6076]},{"teal":6306,"source":"contracts/NFDRegistry.algo.ts:1505","errorMessage":"max expiration exceeded parameters defined by registry","pc":[6138]},{"teal":6333,"source":"contracts/NFDRegistry.algo.ts:1513","errorMessage":"global state value does not exist: AppID.fromUint64(appId).globalState(NFD_KEY_VERSION)","pc":[6155]},{"teal":6364,"source":"contracts/NFDRegistry.algo.ts:51","errorMessage":"this contract does not implement the given ABI method for create NoOp","pc":[6198]}],"pcOffsetMethod":"cblocks"},"clear":{"sourceInfo":[],"pcOffsetMethod":"none"}},"templateVariables":{"adminAsaId":{"type":"uint64"},"nfdTreasuryAddr":{"type":"address"},"nfdCommission1Addr":{"type":"address"},"nfdCommission1Rate":{"type":"uint64"},"algoUsdOracleAppId":{"type":"uint64"},"developmentAllowShortMints":{"type":"uint64"}},"scratchVariables":{"adminAsaId":{"type":"uint64","slot":200},"nfdTreasuryAddr":{"type":"address","slot":201},"nfdCommission1Addr":{"type":"address","slot":202},"nfdCommission1Rate":{"type":"uint64","slot":203},"algoUsdOracleAppId":{"type":"uint64","slot":204},"developmentAllowShortMints":{"type":"uint64","slot":205}},"compilerInfo":{"compiler":"algod","compilerVersion":{"major":3,"minor":27,"patch":237217,"commitHash":"0bc3d7e4"}}} as unknown as Arc56Contract

/**
 * A state record containing binary data
 */
export interface BinaryState {
  /**
   * Gets the state value as a Uint8Array
   */
  asByteArray(): Uint8Array | undefined
  /**
   * Gets the state value as a string
   */
  asString(): string | undefined
}

class BinaryStateValue implements BinaryState {
  constructor(private value: Uint8Array | undefined) {}

  asByteArray(): Uint8Array | undefined {
    return this.value
  }

  asString(): string | undefined {
    return this.value !== undefined ? Buffer.from(this.value).toString('utf-8') : undefined
  }
}

/**
 * Expands types for IntelliSense so they are more human readable
 * See https://stackoverflow.com/a/69288824
 */
export type Expand<T> = T extends (...args: infer A) => infer R
  ? (...args: Expand<A>) => Expand<R>
  : T extends infer O
    ? { [K in keyof O]: O[K] }
    : never


// Type definitions for ARC-56 structs

export type PriceInfo = {
  oneYearPrice: bigint,
  carryCost: bigint,
  exists: boolean,
  isExpired: boolean,
  inAuction: boolean
}


/**
 * Converts the ABI tuple representation of a PriceInfo to the struct representation
 */
export function PriceInfoFromTuple(abiTuple: [bigint, bigint, boolean, boolean, boolean]) {
  return getABIStructFromABITuple(abiTuple, APP_SPEC.structs.PriceInfo, APP_SPEC.structs) as PriceInfo
}

export type Constraints = {
  segmentPlatformCostInUsd: bigint,
  segmentPlatformCostInAlgo: bigint,
  maxYearsAllowed: bigint,
  treasuryAddress: string,
  expiredAuctionDuration: bigint,
  expiredStartingPrice: bigint,
  maxMintCarryCost: bigint
}


/**
 * Converts the ABI tuple representation of a Constraints to the struct representation
 */
export function ConstraintsFromTuple(abiTuple: [bigint, bigint, bigint, string, bigint, bigint, bigint]) {
  return getABIStructFromABITuple(abiTuple, APP_SPEC.structs.Constraints, APP_SPEC.structs) as Constraints
}

export type LinkOnMintExtraMbrCosts = {
  linkingNfdMbrCost: bigint,
  linkingRegistryMbrCost: bigint
}


/**
 * Converts the ABI tuple representation of a LinkOnMintExtraMbrCosts to the struct representation
 */
export function LinkOnMintExtraMbrCostsFromTuple(abiTuple: [bigint, bigint]) {
  return getABIStructFromABITuple(abiTuple, APP_SPEC.structs.LinkOnMintExtraMbrCosts, APP_SPEC.structs) as LinkOnMintExtraMbrCosts
}

/**
 * Deploy-time template variables
 */
export type TemplateVariables = {
  adminAsaId: bigint,
  nfdTreasuryAddr: string,
  nfdCommission1Addr: string,
  nfdCommission1Rate: bigint,
  algoUsdOracleAppId: bigint,
  developmentAllowShortMints: bigint,
}

/**
 * The argument types for the NfdRegistry contract
 */
export type NfdRegistryArgs = {
  /**
   * The object representation of the arguments for each method
   */
  obj: {
    'updateApplication()void': Record<string, never>
    'gas()void': Record<string, never>
    'getPrice(string,address)(uint64,uint64,bool,bool,bool)': {
      /**
       * The NFD name for which to retrieve the price.
       */
      nfdName: string
      /**
      * the address this request is on behalf of (since an nfd contract might call us it
      needs to be able to pass on the request on behalf of ITS caller - ie: getting price for an expired nfd will be
      different if its owner ir asking.
      PriceInfo Type containing the price, carry cost, etc.

       */
      caller: string
    }
    'getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)': Record<string, never>
    'getNfdMbrCost(string)uint64': {
      nfdName: string
    }
    'getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)': {
      address: string
    }
    'mintNfd(pay,string,address,bool)uint64': {
      /**
       * The payment transaction covering the purchase amount of the nfd
       */
      purchaseTxn: AppMethodCallTransactionArgument
      /**
       * The name of the NFD to mint
       */
      nfdName: string
      /**
       * The address that will own the NFD once minted (so you can buy for someone else)
       */
      reservedFor: string
      /**
      * whether to auto-link the address (reserved for MUST MATCH payer!) at mint
      uint64 - The ID of the newly created NFD instance.

       */
      linkOnMint: boolean
    }
    'linkNfdAddress(string,uint64,address)void': {
      nfdName: string
      nfdAppId: bigint | number
      addrToVerify: string
    }
    'unlinkNfdAddress(string,uint64,address)void': {
      nfdName: string
      nfdAppId: bigint | number
      addrToUnlink: string
    }
    'ownershipAssign(string,uint64)void': {
      nfdName: string
      nfdAppId: bigint | number
    }
    'ownershipChanged(string,uint64,address,address)void': {
      /**
       * The name of the NFD.
       */
      nfdName: string
      /**
       * The unique application ID of the NFD.
       */
      nfdAppId: bigint | number
      /**
       * The address of the prior owner (seller) of the nfd
       */
      seller: string
      /**
       * The address of the new owner of the NFD.
       */
      buyer: string
    }
    'setAddressPrimaryNfd(string,uint64,address)void': {
      nfdName: string
      nfdAppId: bigint | number
      addrBeingModified: string
    }
    'upgradeNfd(string)string': {
      nfdName: string
    }
    'isValidNfdAppId(string,uint64)bool': {
      nfdName: string
      nfdAppId: bigint | number
    }
    'getNameAppId(string)uint64': {
      nfdName: string
    }
    'getAddressAppIds(address)uint64[]': {
      lookupAddress: string
    }
    'nfdContractInit(string,uint64,byte[])void': {
      /**
       * The version of the contract.
       */
      version: string
      /**
       * exact byte size of contract to load
       */
      size: bigint | number
      /**
       * bytes of clear code
       */
      clearCode: Uint8Array
    }
    'nfdContractLoad(string,uint64,byte[])void': {
      /**
       * The version of the contract.
       */
      version: string
      /**
       * The offset at which to replace the contract data within the box.
       */
      offset: bigint | number
      /**
       * The contract data to be loaded.
       */
      data: Uint8Array
    }
    'nfdContractCommit(string)void': {
      /**
       * The version number of the contract to be committed.
       */
      version: string
    }
    'usdInMicroAlgo(uint64)uint64': {
      usdCost: bigint | number
    }
    'costToAddToAddress(address)uint64': {
      /**
       * The address to add the NFD app id to
       */
      lookupAddress: string
    }
    'calcFuturePrice(uint64,uint64)uint64': {
      /**
       * The current price in USD (in decimals). For example, if the current price is $2.00, the value should be 200.
       */
      curPrice: bigint | number
      /**
      * The timestamp to calc the future price based on - ie: 1 year past 'go live date' the price would have inflated by 1 year.
      
      
      uint64 The future price calculated based on the current price and the specified number of years.

       */
      forTime: bigint | number
    }
    'createApplication()void': Record<string, never>
  }
  /**
   * The tuple representation of the arguments for each method
   */
  tuple: {
    'updateApplication()void': []
    'gas()void': []
    'getPrice(string,address)(uint64,uint64,bool,bool,bool)': [nfdName: string, caller: string]
    'getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)': []
    'getNfdMbrCost(string)uint64': [nfdName: string]
    'getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)': [address: string]
    'mintNfd(pay,string,address,bool)uint64': [purchaseTxn: AppMethodCallTransactionArgument, nfdName: string, reservedFor: string, linkOnMint: boolean]
    'linkNfdAddress(string,uint64,address)void': [nfdName: string, nfdAppId: bigint | number, addrToVerify: string]
    'unlinkNfdAddress(string,uint64,address)void': [nfdName: string, nfdAppId: bigint | number, addrToUnlink: string]
    'ownershipAssign(string,uint64)void': [nfdName: string, nfdAppId: bigint | number]
    'ownershipChanged(string,uint64,address,address)void': [nfdName: string, nfdAppId: bigint | number, seller: string, buyer: string]
    'setAddressPrimaryNfd(string,uint64,address)void': [nfdName: string, nfdAppId: bigint | number, addrBeingModified: string]
    'upgradeNfd(string)string': [nfdName: string]
    'isValidNfdAppId(string,uint64)bool': [nfdName: string, nfdAppId: bigint | number]
    'getNameAppId(string)uint64': [nfdName: string]
    'getAddressAppIds(address)uint64[]': [lookupAddress: string]
    'nfdContractInit(string,uint64,byte[])void': [version: string, size: bigint | number, clearCode: Uint8Array]
    'nfdContractLoad(string,uint64,byte[])void': [version: string, offset: bigint | number, data: Uint8Array]
    'nfdContractCommit(string)void': [version: string]
    'usdInMicroAlgo(uint64)uint64': [usdCost: bigint | number]
    'costToAddToAddress(address)uint64': [lookupAddress: string]
    'calcFuturePrice(uint64,uint64)uint64': [curPrice: bigint | number, forTime: bigint | number]
    'createApplication()void': []
  }
}

/**
 * The return type for each method
 */
export type NfdRegistryReturns = {
  'updateApplication()void': void
  'gas()void': void
  'getPrice(string,address)(uint64,uint64,bool,bool,bool)': PriceInfo
  'getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)': Constraints
  'getNfdMbrCost(string)uint64': bigint
  'getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)': LinkOnMintExtraMbrCosts
  'mintNfd(pay,string,address,bool)uint64': bigint
  'linkNfdAddress(string,uint64,address)void': void
  'unlinkNfdAddress(string,uint64,address)void': void
  'ownershipAssign(string,uint64)void': void
  'ownershipChanged(string,uint64,address,address)void': void
  'setAddressPrimaryNfd(string,uint64,address)void': void
  'upgradeNfd(string)string': string
  'isValidNfdAppId(string,uint64)bool': boolean
  'getNameAppId(string)uint64': bigint
  'getAddressAppIds(address)uint64[]': bigint[]
  'nfdContractInit(string,uint64,byte[])void': void
  'nfdContractLoad(string,uint64,byte[])void': void
  'nfdContractCommit(string)void': void
  'usdInMicroAlgo(uint64)uint64': bigint
  'costToAddToAddress(address)uint64': bigint
  'calcFuturePrice(uint64,uint64)uint64': bigint
  'createApplication()void': void
}

/**
 * Defines the types of available calls and state of the NfdRegistry smart contract.
 */
export type NfdRegistryTypes = {
  /**
   * Maps method signatures / names to their argument and return types.
   */
  methods:
    & Record<'updateApplication()void' | 'updateApplication', {
      argsObj: NfdRegistryArgs['obj']['updateApplication()void']
      argsTuple: NfdRegistryArgs['tuple']['updateApplication()void']
      returns: NfdRegistryReturns['updateApplication()void']
    }>
    & Record<'gas()void' | 'gas', {
      argsObj: NfdRegistryArgs['obj']['gas()void']
      argsTuple: NfdRegistryArgs['tuple']['gas()void']
      returns: NfdRegistryReturns['gas()void']
    }>
    & Record<'getPrice(string,address)(uint64,uint64,bool,bool,bool)' | 'getPrice', {
      argsObj: NfdRegistryArgs['obj']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']
      argsTuple: NfdRegistryArgs['tuple']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']
      returns: NfdRegistryReturns['getPrice(string,address)(uint64,uint64,bool,bool,bool)']
    }>
    & Record<'getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)' | 'getConstraints', {
      argsObj: NfdRegistryArgs['obj']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']
      argsTuple: NfdRegistryArgs['tuple']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']
      returns: NfdRegistryReturns['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']
    }>
    & Record<'getNfdMbrCost(string)uint64' | 'getNfdMbrCost', {
      argsObj: NfdRegistryArgs['obj']['getNfdMbrCost(string)uint64']
      argsTuple: NfdRegistryArgs['tuple']['getNfdMbrCost(string)uint64']
      returns: NfdRegistryReturns['getNfdMbrCost(string)uint64']
    }>
    & Record<'getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)' | 'getNfdLinkOnMintExtraMbrCost', {
      argsObj: NfdRegistryArgs['obj']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']
      argsTuple: NfdRegistryArgs['tuple']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']
      returns: NfdRegistryReturns['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']
    }>
    & Record<'mintNfd(pay,string,address,bool)uint64' | 'mintNfd', {
      argsObj: NfdRegistryArgs['obj']['mintNfd(pay,string,address,bool)uint64']
      argsTuple: NfdRegistryArgs['tuple']['mintNfd(pay,string,address,bool)uint64']
      returns: NfdRegistryReturns['mintNfd(pay,string,address,bool)uint64']
    }>
    & Record<'linkNfdAddress(string,uint64,address)void' | 'linkNfdAddress', {
      argsObj: NfdRegistryArgs['obj']['linkNfdAddress(string,uint64,address)void']
      argsTuple: NfdRegistryArgs['tuple']['linkNfdAddress(string,uint64,address)void']
      returns: NfdRegistryReturns['linkNfdAddress(string,uint64,address)void']
    }>
    & Record<'unlinkNfdAddress(string,uint64,address)void' | 'unlinkNfdAddress', {
      argsObj: NfdRegistryArgs['obj']['unlinkNfdAddress(string,uint64,address)void']
      argsTuple: NfdRegistryArgs['tuple']['unlinkNfdAddress(string,uint64,address)void']
      returns: NfdRegistryReturns['unlinkNfdAddress(string,uint64,address)void']
    }>
    & Record<'ownershipAssign(string,uint64)void' | 'ownershipAssign', {
      argsObj: NfdRegistryArgs['obj']['ownershipAssign(string,uint64)void']
      argsTuple: NfdRegistryArgs['tuple']['ownershipAssign(string,uint64)void']
      returns: NfdRegistryReturns['ownershipAssign(string,uint64)void']
    }>
    & Record<'ownershipChanged(string,uint64,address,address)void' | 'ownershipChanged', {
      argsObj: NfdRegistryArgs['obj']['ownershipChanged(string,uint64,address,address)void']
      argsTuple: NfdRegistryArgs['tuple']['ownershipChanged(string,uint64,address,address)void']
      returns: NfdRegistryReturns['ownershipChanged(string,uint64,address,address)void']
    }>
    & Record<'setAddressPrimaryNfd(string,uint64,address)void' | 'setAddressPrimaryNfd', {
      argsObj: NfdRegistryArgs['obj']['setAddressPrimaryNfd(string,uint64,address)void']
      argsTuple: NfdRegistryArgs['tuple']['setAddressPrimaryNfd(string,uint64,address)void']
      returns: NfdRegistryReturns['setAddressPrimaryNfd(string,uint64,address)void']
    }>
    & Record<'upgradeNfd(string)string' | 'upgradeNfd', {
      argsObj: NfdRegistryArgs['obj']['upgradeNfd(string)string']
      argsTuple: NfdRegistryArgs['tuple']['upgradeNfd(string)string']
      returns: NfdRegistryReturns['upgradeNfd(string)string']
    }>
    & Record<'isValidNfdAppId(string,uint64)bool' | 'isValidNfdAppId', {
      argsObj: NfdRegistryArgs['obj']['isValidNfdAppId(string,uint64)bool']
      argsTuple: NfdRegistryArgs['tuple']['isValidNfdAppId(string,uint64)bool']
      returns: NfdRegistryReturns['isValidNfdAppId(string,uint64)bool']
    }>
    & Record<'getNameAppId(string)uint64' | 'getNameAppId', {
      argsObj: NfdRegistryArgs['obj']['getNameAppId(string)uint64']
      argsTuple: NfdRegistryArgs['tuple']['getNameAppId(string)uint64']
      returns: NfdRegistryReturns['getNameAppId(string)uint64']
    }>
    & Record<'getAddressAppIds(address)uint64[]' | 'getAddressAppIds', {
      argsObj: NfdRegistryArgs['obj']['getAddressAppIds(address)uint64[]']
      argsTuple: NfdRegistryArgs['tuple']['getAddressAppIds(address)uint64[]']
      returns: NfdRegistryReturns['getAddressAppIds(address)uint64[]']
    }>
    & Record<'nfdContractInit(string,uint64,byte[])void' | 'nfdContractInit', {
      argsObj: NfdRegistryArgs['obj']['nfdContractInit(string,uint64,byte[])void']
      argsTuple: NfdRegistryArgs['tuple']['nfdContractInit(string,uint64,byte[])void']
      returns: NfdRegistryReturns['nfdContractInit(string,uint64,byte[])void']
    }>
    & Record<'nfdContractLoad(string,uint64,byte[])void' | 'nfdContractLoad', {
      argsObj: NfdRegistryArgs['obj']['nfdContractLoad(string,uint64,byte[])void']
      argsTuple: NfdRegistryArgs['tuple']['nfdContractLoad(string,uint64,byte[])void']
      returns: NfdRegistryReturns['nfdContractLoad(string,uint64,byte[])void']
    }>
    & Record<'nfdContractCommit(string)void' | 'nfdContractCommit', {
      argsObj: NfdRegistryArgs['obj']['nfdContractCommit(string)void']
      argsTuple: NfdRegistryArgs['tuple']['nfdContractCommit(string)void']
      returns: NfdRegistryReturns['nfdContractCommit(string)void']
    }>
    & Record<'usdInMicroAlgo(uint64)uint64' | 'usdInMicroAlgo', {
      argsObj: NfdRegistryArgs['obj']['usdInMicroAlgo(uint64)uint64']
      argsTuple: NfdRegistryArgs['tuple']['usdInMicroAlgo(uint64)uint64']
      returns: NfdRegistryReturns['usdInMicroAlgo(uint64)uint64']
    }>
    & Record<'costToAddToAddress(address)uint64' | 'costToAddToAddress', {
      argsObj: NfdRegistryArgs['obj']['costToAddToAddress(address)uint64']
      argsTuple: NfdRegistryArgs['tuple']['costToAddToAddress(address)uint64']
      returns: NfdRegistryReturns['costToAddToAddress(address)uint64']
    }>
    & Record<'calcFuturePrice(uint64,uint64)uint64' | 'calcFuturePrice', {
      argsObj: NfdRegistryArgs['obj']['calcFuturePrice(uint64,uint64)uint64']
      argsTuple: NfdRegistryArgs['tuple']['calcFuturePrice(uint64,uint64)uint64']
      returns: NfdRegistryReturns['calcFuturePrice(uint64,uint64)uint64']
    }>
    & Record<'createApplication()void' | 'createApplication', {
      argsObj: NfdRegistryArgs['obj']['createApplication()void']
      argsTuple: NfdRegistryArgs['tuple']['createApplication()void']
      returns: NfdRegistryReturns['createApplication()void']
    }>
  /**
   * Defines the shape of the state of the application.
   */
  state: {
    local: {
      keys: {}
      maps: {
        localState: Map<Uint8Array | string, Uint8Array>
      }
    }
    box: {
      keys: {}
      maps: {
        boxes: Map<Uint8Array | string, Uint8Array>
      }
    }
  }
}

/**
 * Defines the possible abi call signatures.
 */
export type NfdRegistrySignatures = keyof NfdRegistryTypes['methods']
/**
 * Defines the possible abi call signatures for methods that return a non-void value.
 */
export type NfdRegistryNonVoidMethodSignatures = keyof NfdRegistryTypes['methods'] extends infer T ? T extends keyof NfdRegistryTypes['methods'] ? MethodReturn<T> extends void ? never : T  : never : never
/**
 * Defines an object containing all relevant parameters for a single call to the contract.
 */
export type CallParams<TArgs> = Expand<
  Omit<AppClientMethodCallParams, 'method' | 'args' | 'onComplete'> &
    {
      /** The args for the ABI method call, either as an ordered array or an object */
      args: Expand<TArgs>
    }
>
/**
 * Maps a method signature from the NfdRegistry smart contract to the method's arguments in either tuple or struct form
 */
export type MethodArgs<TSignature extends NfdRegistrySignatures> = NfdRegistryTypes['methods'][TSignature]['argsObj' | 'argsTuple']
/**
 * Maps a method signature from the NfdRegistry smart contract to the method's return type
 */
export type MethodReturn<TSignature extends NfdRegistrySignatures> = NfdRegistryTypes['methods'][TSignature]['returns']

/**
 * Defines the shape of the keyed local state of the application.
 */
export type LocalKeysState = NfdRegistryTypes['state']['local']['keys']

/**
 * Defines the shape of the keyed box state of the application.
 */
export type BoxKeysState = NfdRegistryTypes['state']['box']['keys']


/**
 * Defines supported create method params for this smart contract
 */
export type NfdRegistryCreateCallParams =
  | Expand<CallParams<NfdRegistryArgs['obj']['createApplication()void'] | NfdRegistryArgs['tuple']['createApplication()void']> & {method: 'createApplication'} & {onComplete?: OnApplicationComplete.NoOpOC} & CreateSchema>
  | Expand<CallParams<NfdRegistryArgs['obj']['createApplication()void'] | NfdRegistryArgs['tuple']['createApplication()void']> & {method: 'createApplication()void'} & {onComplete?: OnApplicationComplete.NoOpOC} & CreateSchema>
/**
 * Defines supported update method params for this smart contract
 */
export type NfdRegistryUpdateCallParams =
  | Expand<CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & {method: 'updateApplication'}>
  | Expand<CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & {method: 'updateApplication()void'}>
/**
 * Defines arguments required for the deploy method.
 */
export type NfdRegistryDeployParams = Expand<Omit<AppFactoryDeployParams, 'createParams' | 'updateParams' | 'deleteParams'> & {
  /**
   * Create transaction parameters to use if a create needs to be issued as part of deployment; use `method` to define ABI call (if available) or leave out for a bare call (if available)
   */
  createParams?: NfdRegistryCreateCallParams
  /**
   * Update transaction parameters to use if a create needs to be issued as part of deployment; use `method` to define ABI call (if available) or leave out for a bare call (if available)
   */
  updateParams?: NfdRegistryUpdateCallParams
}>


/**
 * Exposes methods for constructing `AppClient` params objects for ABI calls to the NfdRegistry smart contract
 */
export abstract class NfdRegistryParamsFactory {
  /**
   * Gets available create ABI call param factories
   */
  static get create() {
    return {
      _resolveByMethod<TParams extends NfdRegistryCreateCallParams & {method: string}>(params: TParams) {
        switch(params.method) {
          case 'createApplication':
          case 'createApplication()void':
            return NfdRegistryParamsFactory.create.createApplication(params)
        }
        throw new Error(`Unknown ' + verb + ' method`)
      },

      /**
       * Constructs create ABI call params for the NFDRegistry smart contract using the createApplication()void ABI method
       *
       * @param params Parameters for the call
       * @returns An `AppClientMethodCallParams` object for the call
       */
      createApplication(params: CallParams<NfdRegistryArgs['obj']['createApplication()void'] | NfdRegistryArgs['tuple']['createApplication()void']> & AppClientCompilationParams & {onComplete?: OnApplicationComplete.NoOpOC}): AppClientMethodCallParams & AppClientCompilationParams & {onComplete?: OnApplicationComplete.NoOpOC} {
        return {
          ...params,
          method: 'createApplication()void' as const,
          args: Array.isArray(params.args) ? params.args : [],
        }
      },
    }
  }

  /**
   * Gets available update ABI call param factories
   */
  static get update() {
    return {
      _resolveByMethod<TParams extends NfdRegistryUpdateCallParams & {method: string}>(params: TParams) {
        switch(params.method) {
          case 'updateApplication':
          case 'updateApplication()void':
            return NfdRegistryParamsFactory.update.updateApplication(params)
        }
        throw new Error(`Unknown ' + verb + ' method`)
      },

      /**
       * Constructs update ABI call params for the NFDRegistry smart contract using the updateApplication()void ABI method
       *
       * @param params Parameters for the call
       * @returns An `AppClientMethodCallParams` object for the call
       */
      updateApplication(params: CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & AppClientCompilationParams): AppClientMethodCallParams & AppClientCompilationParams {
        return {
          ...params,
          method: 'updateApplication()void' as const,
          args: Array.isArray(params.args) ? params.args : [],
        }
      },
    }
  }

  /**
   * Constructs a no op call for the gas()void ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static gas(params: CallParams<NfdRegistryArgs['obj']['gas()void'] | NfdRegistryArgs['tuple']['gas()void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'gas()void' as const,
      args: Array.isArray(params.args) ? params.args : [],
    }
  }
  /**
   * Constructs a no op call for the getPrice(string,address)(uint64,uint64,bool,bool,bool) ABI method
   *
  * Returns the price for a given NFD (single year), the max # of years allowed (Name for Display),
  and extra algo required to cover MBR when purchasing.

   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static getPrice(params: CallParams<NfdRegistryArgs['obj']['getPrice(string,address)(uint64,uint64,bool,bool,bool)'] | NfdRegistryArgs['tuple']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'getPrice(string,address)(uint64,uint64,bool,bool,bool)' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName, params.args.caller],
    }
  }
  /**
   * Constructs a no op call for the getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64) ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static getConstraints(params: CallParams<NfdRegistryArgs['obj']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'] | NfdRegistryArgs['tuple']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)' as const,
      args: Array.isArray(params.args) ? params.args : [],
    }
  }
  /**
   * Constructs a no op call for the getNfdMbrCost(string)uint64 ABI method
   *
  * Returns the MBR amounts needed to MINT an nfd.
  This value needs to be added to purchase price in mintNfd call.
  getPrice() returns it though.

   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static getNfdMbrCost(params: CallParams<NfdRegistryArgs['obj']['getNfdMbrCost(string)uint64'] | NfdRegistryArgs['tuple']['getNfdMbrCost(string)uint64']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'getNfdMbrCost(string)uint64' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName],
    }
  }
  /**
   * Constructs a no op call for the getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64) ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static getNfdLinkOnMintExtraMbrCost(params: CallParams<NfdRegistryArgs['obj']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'] | NfdRegistryArgs['tuple']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.address],
    }
  }
  /**
   * Constructs a no op call for the mintNfd(pay,string,address,bool)uint64 ABI method
   *
   * Mint an NFD (NFT) and create a new NFD instance.
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static mintNfd(params: CallParams<NfdRegistryArgs['obj']['mintNfd(pay,string,address,bool)uint64'] | NfdRegistryArgs['tuple']['mintNfd(pay,string,address,bool)uint64']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'mintNfd(pay,string,address,bool)uint64' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.purchaseTxn, params.args.nfdName, params.args.reservedFor, params.args.linkOnMint],
    }
  }
  /**
   * Constructs a no op call for the linkNfdAddress(string,uint64,address)void ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static linkNfdAddress(params: CallParams<NfdRegistryArgs['obj']['linkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['linkNfdAddress(string,uint64,address)void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'linkNfdAddress(string,uint64,address)void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName, params.args.nfdAppId, params.args.addrToVerify],
    }
  }
  /**
   * Constructs a no op call for the unlinkNfdAddress(string,uint64,address)void ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static unlinkNfdAddress(params: CallParams<NfdRegistryArgs['obj']['unlinkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['unlinkNfdAddress(string,uint64,address)void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'unlinkNfdAddress(string,uint64,address)void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName, params.args.nfdAppId, params.args.addrToUnlink],
    }
  }
  /**
   * Constructs a no op call for the ownershipAssign(string,uint64)void ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static ownershipAssign(params: CallParams<NfdRegistryArgs['obj']['ownershipAssign(string,uint64)void'] | NfdRegistryArgs['tuple']['ownershipAssign(string,uint64)void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'ownershipAssign(string,uint64)void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName, params.args.nfdAppId],
    }
  }
  /**
   * Constructs a no op call for the ownershipChanged(string,uint64,address,address)void ABI method
   *
  * This method is triggered when the ownership of an NFD (Non-Fungible Domain) changes.
  It is called by the NFD via the purchase method.  It can also be called by TxnLab admin for older 3.3
  NFDs when it detects purchased events for 3.3

   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static ownershipChanged(params: CallParams<NfdRegistryArgs['obj']['ownershipChanged(string,uint64,address,address)void'] | NfdRegistryArgs['tuple']['ownershipChanged(string,uint64,address,address)void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'ownershipChanged(string,uint64,address,address)void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName, params.args.nfdAppId, params.args.seller, params.args.buyer],
    }
  }
  /**
   * Constructs a no op call for the setAddressPrimaryNfd(string,uint64,address)void ABI method
   *
  * Makes the specified NFD the 'first' NFD in the reverse-address set so its the primary NFD for this address.
  The NFD must be valid, and the sender must be the address (or nfd owner if vault).  The NFD wouldn't already be
  in the reverse-lookup set if it wasn't already valid.

   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static setAddressPrimaryNfd(params: CallParams<NfdRegistryArgs['obj']['setAddressPrimaryNfd(string,uint64,address)void'] | NfdRegistryArgs['tuple']['setAddressPrimaryNfd(string,uint64,address)void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'setAddressPrimaryNfd(string,uint64,address)void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName, params.args.nfdAppId, params.args.addrBeingModified],
    }
  }
  /**
   * Constructs a no op call for the upgradeNfd(string)string ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static upgradeNfd(params: CallParams<NfdRegistryArgs['obj']['upgradeNfd(string)string'] | NfdRegistryArgs['tuple']['upgradeNfd(string)string']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'upgradeNfd(string)string' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName],
    }
  }
  /**
   * Constructs a no op call for the isValidNfdAppId(string,uint64)bool ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static isValidNfdAppId(params: CallParams<NfdRegistryArgs['obj']['isValidNfdAppId(string,uint64)bool'] | NfdRegistryArgs['tuple']['isValidNfdAppId(string,uint64)bool']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'isValidNfdAppId(string,uint64)bool' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName, params.args.nfdAppId],
    }
  }
  /**
   * Constructs a no op call for the getNameAppId(string)uint64 ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static getNameAppId(params: CallParams<NfdRegistryArgs['obj']['getNameAppId(string)uint64'] | NfdRegistryArgs['tuple']['getNameAppId(string)uint64']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'getNameAppId(string)uint64' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.nfdName],
    }
  }
  /**
   * Constructs a no op call for the getAddressAppIds(address)uint64[] ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static getAddressAppIds(params: CallParams<NfdRegistryArgs['obj']['getAddressAppIds(address)uint64[]'] | NfdRegistryArgs['tuple']['getAddressAppIds(address)uint64[]']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'getAddressAppIds(address)uint64[]' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.lookupAddress],
    }
  }
  /**
   * Constructs a no op call for the nfdContractInit(string,uint64,byte[])void ABI method
   *
   * Initializes the NFD contract bytecode into the registry
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static nfdContractInit(params: CallParams<NfdRegistryArgs['obj']['nfdContractInit(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractInit(string,uint64,byte[])void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'nfdContractInit(string,uint64,byte[])void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.version, params.args.size, params.args.clearCode],
    }
  }
  /**
   * Constructs a no op call for the nfdContractLoad(string,uint64,byte[])void ABI method
   *
   * Loads contract data into the  box at the specified offset.
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static nfdContractLoad(params: CallParams<NfdRegistryArgs['obj']['nfdContractLoad(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractLoad(string,uint64,byte[])void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'nfdContractLoad(string,uint64,byte[])void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.version, params.args.offset, params.args.data],
    }
  }
  /**
   * Constructs a no op call for the nfdContractCommit(string)void ABI method
   *
   * Commit a new version of the contract.
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static nfdContractCommit(params: CallParams<NfdRegistryArgs['obj']['nfdContractCommit(string)void'] | NfdRegistryArgs['tuple']['nfdContractCommit(string)void']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'nfdContractCommit(string)void' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.version],
    }
  }
  /**
   * Constructs a no op call for the usdInMicroAlgo(uint64)uint64 ABI method
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static usdInMicroAlgo(params: CallParams<NfdRegistryArgs['obj']['usdInMicroAlgo(uint64)uint64'] | NfdRegistryArgs['tuple']['usdInMicroAlgo(uint64)uint64']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'usdInMicroAlgo(uint64)uint64' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.usdCost],
    }
  }
  /**
   * Constructs a no op call for the costToAddToAddress(address)uint64 ABI method
   *
   * Returns the cost to add an NFD to the reverse-lookup data
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static costToAddToAddress(params: CallParams<NfdRegistryArgs['obj']['costToAddToAddress(address)uint64'] | NfdRegistryArgs['tuple']['costToAddToAddress(address)uint64']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'costToAddToAddress(address)uint64' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.lookupAddress],
    }
  }
  /**
   * Constructs a no op call for the calcFuturePrice(uint64,uint64)uint64 ABI method
   *
   * Calculates the future price based on the current price and the number of years.
   *
   * @param params Parameters for the call
   * @returns An `AppClientMethodCallParams` object for the call
   */
  static calcFuturePrice(params: CallParams<NfdRegistryArgs['obj']['calcFuturePrice(uint64,uint64)uint64'] | NfdRegistryArgs['tuple']['calcFuturePrice(uint64,uint64)uint64']> & CallOnComplete): AppClientMethodCallParams & CallOnComplete {
    return {
      ...params,
      method: 'calcFuturePrice(uint64,uint64)uint64' as const,
      args: Array.isArray(params.args) ? params.args : [params.args.curPrice, params.args.forTime],
    }
  }
}

/**
 * A factory to create and deploy one or more instance of the NFDRegistry smart contract and to create one or more app clients to interact with those (or other) app instances
 */
export class NfdRegistryFactory {
  /**
   * The underlying `AppFactory` for when you want to have more flexibility
   */
  public readonly appFactory: _AppFactory

  /**
   * Creates a new instance of `NfdRegistryFactory`
   *
   * @param params The parameters to initialise the app factory with
   */
  constructor(params: Omit<AppFactoryParams, 'appSpec'>) {
    this.appFactory = new _AppFactory({
      ...params,
      appSpec: APP_SPEC,
    })
  }
  
  /** The name of the app (from the ARC-32 / ARC-56 app spec or override). */
  public get appName() {
    return this.appFactory.appName
  }
  
  /** The ARC-56 app spec being used */
  get appSpec() {
    return APP_SPEC
  }
  
  /** A reference to the underlying `AlgorandClient` this app factory is using. */
  public get algorand(): AlgorandClientInterface {
    return this.appFactory.algorand
  }
  
  /**
   * Returns a new `AppClient` client for an app instance of the given ID.
   *
   * Automatically populates appName, defaultSender and source maps from the factory
   * if not specified in the params.
   * @param params The parameters to create the app client
   * @returns The `AppClient`
   */
  public getAppClientById(params: AppFactoryAppClientParams) {
    return new NfdRegistryClient(this.appFactory.getAppClientById(params))
  }
  
  /**
   * Returns a new `AppClient` client, resolving the app by creator address and name
   * using AlgoKit app deployment semantics (i.e. looking for the app creation transaction note).
   *
   * Automatically populates appName, defaultSender and source maps from the factory
   * if not specified in the params.
   * @param params The parameters to create the app client
   * @returns The `AppClient`
   */
  public async getAppClientByCreatorAndName(
    params: AppFactoryResolveAppClientByCreatorAndNameParams,
  ) {
    return new NfdRegistryClient(await this.appFactory.getAppClientByCreatorAndName(params))
  }

  /**
   * Idempotently deploys the NFDRegistry smart contract.
   *
   * @param params The arguments for the contract calls and any additional parameters for the call
   * @returns The deployment result
   */
  public async deploy(params: NfdRegistryDeployParams = {}) {
    const result = await this.appFactory.deploy({
      ...params,
      createParams: params.createParams?.method ? NfdRegistryParamsFactory.create._resolveByMethod(params.createParams) : params.createParams ? params.createParams as (NfdRegistryCreateCallParams & { args: Uint8Array[] }) : undefined,
      updateParams: params.updateParams?.method ? NfdRegistryParamsFactory.update._resolveByMethod(params.updateParams) : params.updateParams ? params.updateParams as (NfdRegistryUpdateCallParams & { args: Uint8Array[] }) : undefined,
    })
    return { result: result.result, appClient: new NfdRegistryClient(result.appClient) }
  }

  /**
   * Get parameters to create transactions (create and deploy related calls) for the current app. A good mental model for this is that these parameters represent a deferred transaction creation.
   */
  readonly params = {
    /**
     * Gets available create methods
     */
    create: {
      /**
       * Creates a new instance of the NFDRegistry smart contract using the createApplication()void ABI method.
       *
       * @param params The params for the smart contract call
       * @returns The create params
       */
      createApplication: (params: CallParams<NfdRegistryArgs['obj']['createApplication()void'] | NfdRegistryArgs['tuple']['createApplication()void']> & AppClientCompilationParams & CreateSchema & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
        return this.appFactory.params.create(NfdRegistryParamsFactory.create.createApplication(params))
      },
    },

    /**
     * Gets available deployUpdate methods
     */
    deployUpdate: {
      /**
       * Updates an existing instance of the NFDRegistry smart contract using the updateApplication()void ABI method.
       *
       * @param params The params for the smart contract call
       * @returns The deployUpdate params
       */
      updateApplication: (params: CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & AppClientCompilationParams = {args: []}) => {
        return this.appFactory.params.deployUpdate(NfdRegistryParamsFactory.update.updateApplication(params))
      },
    },

  }

  /**
   * Create transactions for the current app
   */
  readonly createTransaction = {
    /**
     * Gets available create methods
     */
    create: {
      /**
       * Creates a new instance of the NFDRegistry smart contract using the createApplication()void ABI method.
       *
       * @param params The params for the smart contract call
       * @returns The create transaction
       */
      createApplication: (params: CallParams<NfdRegistryArgs['obj']['createApplication()void'] | NfdRegistryArgs['tuple']['createApplication()void']> & AppClientCompilationParams & CreateSchema & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
        return this.appFactory.createTransaction.create(NfdRegistryParamsFactory.create.createApplication(params))
      },
    },

  }

  /**
   * Send calls to the current app
   */
  readonly send = {
    /**
     * Gets available create methods
     */
    create: {
      /**
       * Creates a new instance of the NFDRegistry smart contract using an ABI method call using the createApplication()void ABI method.
       *
       * @param params The params for the smart contract call
       * @returns The create result
       */
      createApplication: async (params: CallParams<NfdRegistryArgs['obj']['createApplication()void'] | NfdRegistryArgs['tuple']['createApplication()void']> & AppClientCompilationParams & CreateSchema & SendParams & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
        const result = await this.appFactory.send.create(NfdRegistryParamsFactory.create.createApplication(params))
        return { result: { ...result.result, return: result.result.return as unknown as (undefined | NfdRegistryReturns['createApplication()void']) }, appClient: new NfdRegistryClient(result.appClient) }
      },
    },

  }

}
/**
 * A client to make calls to the NFDRegistry smart contract
 */
export class NfdRegistryClient {
  /**
   * The underlying `AppClient` for when you want to have more flexibility
   */
  public readonly appClient: _AppClient

  /**
   * Creates a new instance of `NfdRegistryClient`
   *
   * @param appClient An `AppClient` instance which has been created with the NfdRegistry app spec
   */
  constructor(appClient: _AppClient)
  /**
   * Creates a new instance of `NfdRegistryClient`
   *
   * @param params The parameters to initialise the app client with
   */
  constructor(params: Omit<AppClientParams, 'appSpec'>)
  constructor(appClientOrParams: _AppClient | Omit<AppClientParams, 'appSpec'>) {
    this.appClient = appClientOrParams instanceof _AppClient ? appClientOrParams : new _AppClient({
      ...appClientOrParams,
      appSpec: APP_SPEC,
    })
  }
  
  /**
   * Checks for decode errors on the given return value and maps the return value to the return type for the given method
   * @returns The typed return value or undefined if there was no value
   */
  decodeReturnValue<TSignature extends NfdRegistryNonVoidMethodSignatures>(method: TSignature, returnValue: ABIReturn | undefined) {
    return returnValue !== undefined ? getArc56ReturnValue<MethodReturn<TSignature>>(returnValue, this.appClient.getABIMethod(method), APP_SPEC.structs) : undefined
  }
  
  /**
   * Returns a new `NfdRegistryClient` client, resolving the app by creator address and name
   * using AlgoKit app deployment semantics (i.e. looking for the app creation transaction note).
   * @param params The parameters to create the app client
   */
  public static async fromCreatorAndName(params: Omit<ResolveAppClientByCreatorAndName, 'appSpec'>): Promise<NfdRegistryClient> {
    return new NfdRegistryClient(await _AppClient.fromCreatorAndName({...params, appSpec: APP_SPEC}))
  }
  
  /**
   * Returns an `NfdRegistryClient` instance for the current network based on
   * pre-determined network-specific app IDs specified in the ARC-56 app spec.
   *
   * If no IDs are in the app spec or the network isn't recognised, an error is thrown.
   * @param params The parameters to create the app client
   */
  static async fromNetwork(
    params: Omit<ResolveAppClientByNetwork, 'appSpec'>
  ): Promise<NfdRegistryClient> {
    return new NfdRegistryClient(await _AppClient.fromNetwork({...params, appSpec: APP_SPEC}))
  }
  
  /** The ID of the app instance this client is linked to. */
  public get appId() {
    return this.appClient.appId
  }
  
  /** The app address of the app instance this client is linked to. */
  public get appAddress() {
    return this.appClient.appAddress
  }
  
  /** The name of the app. */
  public get appName() {
    return this.appClient.appName
  }
  
  /** The ARC-56 app spec being used */
  public get appSpec() {
    return this.appClient.appSpec
  }
  
  /** A reference to the underlying `AlgorandClient` this app client is using. */
  public get algorand(): AlgorandClientInterface {
    return this.appClient.algorand
  }

  /**
   * Get parameters to create transactions for the current app. A good mental model for this is that these parameters represent a deferred transaction creation.
   */
  readonly params = {
    /**
     * Gets available update methods
     */
    update: {
      /**
       * Updates an existing instance of the NFDRegistry smart contract using the `updateApplication()void` ABI method.
       *
       * @param params The params for the smart contract call
       * @returns The update params
       */
      updateApplication: (params: CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & AppClientCompilationParams = {args: []}) => {
        return this.appClient.params.update(NfdRegistryParamsFactory.update.updateApplication(params))
      },

    },

    /**
     * Makes a clear_state call to an existing instance of the NFDRegistry smart contract.
     *
     * @param params The params for the bare (raw) call
     * @returns The clearState result
     */
    clearState: (params?: Expand<AppClientBareCallParams>) => {
      return this.appClient.params.bare.clearState(params)
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `gas()void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    gas: (params: CallParams<NfdRegistryArgs['obj']['gas()void'] | NfdRegistryArgs['tuple']['gas()void']> & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.gas(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getPrice(string,address)(uint64,uint64,bool,bool,bool)` ABI method.
     *
    * Returns the price for a given NFD (single year), the max # of years allowed (Name for Display),
    and extra algo required to cover MBR when purchasing.

     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    getPrice: (params: CallParams<NfdRegistryArgs['obj']['getPrice(string,address)(uint64,uint64,bool,bool,bool)'] | NfdRegistryArgs['tuple']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.getPrice(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    getConstraints: (params: CallParams<NfdRegistryArgs['obj']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'] | NfdRegistryArgs['tuple']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']> & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.getConstraints(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNfdMbrCost(string)uint64` ABI method.
     *
    * Returns the MBR amounts needed to MINT an nfd.
    This value needs to be added to purchase price in mintNfd call.
    getPrice() returns it though.

     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    getNfdMbrCost: (params: CallParams<NfdRegistryArgs['obj']['getNfdMbrCost(string)uint64'] | NfdRegistryArgs['tuple']['getNfdMbrCost(string)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.getNfdMbrCost(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    getNfdLinkOnMintExtraMbrCost: (params: CallParams<NfdRegistryArgs['obj']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'] | NfdRegistryArgs['tuple']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.getNfdLinkOnMintExtraMbrCost(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `mintNfd(pay,string,address,bool)uint64` ABI method.
     *
     * Mint an NFD (NFT) and create a new NFD instance.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    mintNfd: (params: CallParams<NfdRegistryArgs['obj']['mintNfd(pay,string,address,bool)uint64'] | NfdRegistryArgs['tuple']['mintNfd(pay,string,address,bool)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.mintNfd(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `linkNfdAddress(string,uint64,address)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    linkNfdAddress: (params: CallParams<NfdRegistryArgs['obj']['linkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['linkNfdAddress(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.linkNfdAddress(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `unlinkNfdAddress(string,uint64,address)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    unlinkNfdAddress: (params: CallParams<NfdRegistryArgs['obj']['unlinkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['unlinkNfdAddress(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.unlinkNfdAddress(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `ownershipAssign(string,uint64)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    ownershipAssign: (params: CallParams<NfdRegistryArgs['obj']['ownershipAssign(string,uint64)void'] | NfdRegistryArgs['tuple']['ownershipAssign(string,uint64)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.ownershipAssign(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `ownershipChanged(string,uint64,address,address)void` ABI method.
     *
    * This method is triggered when the ownership of an NFD (Non-Fungible Domain) changes.
    It is called by the NFD via the purchase method.  It can also be called by TxnLab admin for older 3.3
    NFDs when it detects purchased events for 3.3

     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    ownershipChanged: (params: CallParams<NfdRegistryArgs['obj']['ownershipChanged(string,uint64,address,address)void'] | NfdRegistryArgs['tuple']['ownershipChanged(string,uint64,address,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.ownershipChanged(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `setAddressPrimaryNfd(string,uint64,address)void` ABI method.
     *
    * Makes the specified NFD the 'first' NFD in the reverse-address set so its the primary NFD for this address.
    The NFD must be valid, and the sender must be the address (or nfd owner if vault).  The NFD wouldn't already be
    in the reverse-lookup set if it wasn't already valid.

     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    setAddressPrimaryNfd: (params: CallParams<NfdRegistryArgs['obj']['setAddressPrimaryNfd(string,uint64,address)void'] | NfdRegistryArgs['tuple']['setAddressPrimaryNfd(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.setAddressPrimaryNfd(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `upgradeNfd(string)string` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    upgradeNfd: (params: CallParams<NfdRegistryArgs['obj']['upgradeNfd(string)string'] | NfdRegistryArgs['tuple']['upgradeNfd(string)string']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.upgradeNfd(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `isValidNfdAppId(string,uint64)bool` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    isValidNfdAppId: (params: CallParams<NfdRegistryArgs['obj']['isValidNfdAppId(string,uint64)bool'] | NfdRegistryArgs['tuple']['isValidNfdAppId(string,uint64)bool']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.isValidNfdAppId(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNameAppId(string)uint64` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    getNameAppId: (params: CallParams<NfdRegistryArgs['obj']['getNameAppId(string)uint64'] | NfdRegistryArgs['tuple']['getNameAppId(string)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.getNameAppId(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getAddressAppIds(address)uint64[]` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    getAddressAppIds: (params: CallParams<NfdRegistryArgs['obj']['getAddressAppIds(address)uint64[]'] | NfdRegistryArgs['tuple']['getAddressAppIds(address)uint64[]']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.getAddressAppIds(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractInit(string,uint64,byte[])void` ABI method.
     *
     * Initializes the NFD contract bytecode into the registry
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    nfdContractInit: (params: CallParams<NfdRegistryArgs['obj']['nfdContractInit(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractInit(string,uint64,byte[])void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.nfdContractInit(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractLoad(string,uint64,byte[])void` ABI method.
     *
     * Loads contract data into the  box at the specified offset.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    nfdContractLoad: (params: CallParams<NfdRegistryArgs['obj']['nfdContractLoad(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractLoad(string,uint64,byte[])void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.nfdContractLoad(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractCommit(string)void` ABI method.
     *
     * Commit a new version of the contract.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    nfdContractCommit: (params: CallParams<NfdRegistryArgs['obj']['nfdContractCommit(string)void'] | NfdRegistryArgs['tuple']['nfdContractCommit(string)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.nfdContractCommit(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `usdInMicroAlgo(uint64)uint64` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    usdInMicroAlgo: (params: CallParams<NfdRegistryArgs['obj']['usdInMicroAlgo(uint64)uint64'] | NfdRegistryArgs['tuple']['usdInMicroAlgo(uint64)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.usdInMicroAlgo(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `costToAddToAddress(address)uint64` ABI method.
     *
     * Returns the cost to add an NFD to the reverse-lookup data
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    costToAddToAddress: (params: CallParams<NfdRegistryArgs['obj']['costToAddToAddress(address)uint64'] | NfdRegistryArgs['tuple']['costToAddToAddress(address)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.costToAddToAddress(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `calcFuturePrice(uint64,uint64)uint64` ABI method.
     *
     * Calculates the future price based on the current price and the number of years.
     *
     * @param params The params for the smart contract call
     * @returns The call params
     */
    calcFuturePrice: (params: CallParams<NfdRegistryArgs['obj']['calcFuturePrice(uint64,uint64)uint64'] | NfdRegistryArgs['tuple']['calcFuturePrice(uint64,uint64)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.params.call(NfdRegistryParamsFactory.calcFuturePrice(params))
    },

  }

  /**
   * Create transactions for the current app
   */
  readonly createTransaction = {
    /**
     * Gets available update methods
     */
    update: {
      /**
       * Updates an existing instance of the NFDRegistry smart contract using the `updateApplication()void` ABI method.
       *
       * @param params The params for the smart contract call
       * @returns The update transaction
       */
      updateApplication: (params: CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & AppClientCompilationParams = {args: []}) => {
        return this.appClient.createTransaction.update(NfdRegistryParamsFactory.update.updateApplication(params))
      },

    },

    /**
     * Makes a clear_state call to an existing instance of the NFDRegistry smart contract.
     *
     * @param params The params for the bare (raw) call
     * @returns The clearState result
     */
    clearState: (params?: Expand<AppClientBareCallParams>) => {
      return this.appClient.createTransaction.bare.clearState(params)
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `gas()void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    gas: (params: CallParams<NfdRegistryArgs['obj']['gas()void'] | NfdRegistryArgs['tuple']['gas()void']> & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.gas(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getPrice(string,address)(uint64,uint64,bool,bool,bool)` ABI method.
     *
    * Returns the price for a given NFD (single year), the max # of years allowed (Name for Display),
    and extra algo required to cover MBR when purchasing.

     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    getPrice: (params: CallParams<NfdRegistryArgs['obj']['getPrice(string,address)(uint64,uint64,bool,bool,bool)'] | NfdRegistryArgs['tuple']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.getPrice(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    getConstraints: (params: CallParams<NfdRegistryArgs['obj']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'] | NfdRegistryArgs['tuple']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']> & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.getConstraints(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNfdMbrCost(string)uint64` ABI method.
     *
    * Returns the MBR amounts needed to MINT an nfd.
    This value needs to be added to purchase price in mintNfd call.
    getPrice() returns it though.

     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    getNfdMbrCost: (params: CallParams<NfdRegistryArgs['obj']['getNfdMbrCost(string)uint64'] | NfdRegistryArgs['tuple']['getNfdMbrCost(string)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.getNfdMbrCost(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    getNfdLinkOnMintExtraMbrCost: (params: CallParams<NfdRegistryArgs['obj']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'] | NfdRegistryArgs['tuple']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.getNfdLinkOnMintExtraMbrCost(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `mintNfd(pay,string,address,bool)uint64` ABI method.
     *
     * Mint an NFD (NFT) and create a new NFD instance.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    mintNfd: (params: CallParams<NfdRegistryArgs['obj']['mintNfd(pay,string,address,bool)uint64'] | NfdRegistryArgs['tuple']['mintNfd(pay,string,address,bool)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.mintNfd(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `linkNfdAddress(string,uint64,address)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    linkNfdAddress: (params: CallParams<NfdRegistryArgs['obj']['linkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['linkNfdAddress(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.linkNfdAddress(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `unlinkNfdAddress(string,uint64,address)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    unlinkNfdAddress: (params: CallParams<NfdRegistryArgs['obj']['unlinkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['unlinkNfdAddress(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.unlinkNfdAddress(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `ownershipAssign(string,uint64)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    ownershipAssign: (params: CallParams<NfdRegistryArgs['obj']['ownershipAssign(string,uint64)void'] | NfdRegistryArgs['tuple']['ownershipAssign(string,uint64)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.ownershipAssign(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `ownershipChanged(string,uint64,address,address)void` ABI method.
     *
    * This method is triggered when the ownership of an NFD (Non-Fungible Domain) changes.
    It is called by the NFD via the purchase method.  It can also be called by TxnLab admin for older 3.3
    NFDs when it detects purchased events for 3.3

     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    ownershipChanged: (params: CallParams<NfdRegistryArgs['obj']['ownershipChanged(string,uint64,address,address)void'] | NfdRegistryArgs['tuple']['ownershipChanged(string,uint64,address,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.ownershipChanged(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `setAddressPrimaryNfd(string,uint64,address)void` ABI method.
     *
    * Makes the specified NFD the 'first' NFD in the reverse-address set so its the primary NFD for this address.
    The NFD must be valid, and the sender must be the address (or nfd owner if vault).  The NFD wouldn't already be
    in the reverse-lookup set if it wasn't already valid.

     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    setAddressPrimaryNfd: (params: CallParams<NfdRegistryArgs['obj']['setAddressPrimaryNfd(string,uint64,address)void'] | NfdRegistryArgs['tuple']['setAddressPrimaryNfd(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.setAddressPrimaryNfd(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `upgradeNfd(string)string` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    upgradeNfd: (params: CallParams<NfdRegistryArgs['obj']['upgradeNfd(string)string'] | NfdRegistryArgs['tuple']['upgradeNfd(string)string']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.upgradeNfd(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `isValidNfdAppId(string,uint64)bool` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    isValidNfdAppId: (params: CallParams<NfdRegistryArgs['obj']['isValidNfdAppId(string,uint64)bool'] | NfdRegistryArgs['tuple']['isValidNfdAppId(string,uint64)bool']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.isValidNfdAppId(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNameAppId(string)uint64` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    getNameAppId: (params: CallParams<NfdRegistryArgs['obj']['getNameAppId(string)uint64'] | NfdRegistryArgs['tuple']['getNameAppId(string)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.getNameAppId(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getAddressAppIds(address)uint64[]` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    getAddressAppIds: (params: CallParams<NfdRegistryArgs['obj']['getAddressAppIds(address)uint64[]'] | NfdRegistryArgs['tuple']['getAddressAppIds(address)uint64[]']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.getAddressAppIds(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractInit(string,uint64,byte[])void` ABI method.
     *
     * Initializes the NFD contract bytecode into the registry
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    nfdContractInit: (params: CallParams<NfdRegistryArgs['obj']['nfdContractInit(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractInit(string,uint64,byte[])void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.nfdContractInit(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractLoad(string,uint64,byte[])void` ABI method.
     *
     * Loads contract data into the  box at the specified offset.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    nfdContractLoad: (params: CallParams<NfdRegistryArgs['obj']['nfdContractLoad(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractLoad(string,uint64,byte[])void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.nfdContractLoad(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractCommit(string)void` ABI method.
     *
     * Commit a new version of the contract.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    nfdContractCommit: (params: CallParams<NfdRegistryArgs['obj']['nfdContractCommit(string)void'] | NfdRegistryArgs['tuple']['nfdContractCommit(string)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.nfdContractCommit(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `usdInMicroAlgo(uint64)uint64` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    usdInMicroAlgo: (params: CallParams<NfdRegistryArgs['obj']['usdInMicroAlgo(uint64)uint64'] | NfdRegistryArgs['tuple']['usdInMicroAlgo(uint64)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.usdInMicroAlgo(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `costToAddToAddress(address)uint64` ABI method.
     *
     * Returns the cost to add an NFD to the reverse-lookup data
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    costToAddToAddress: (params: CallParams<NfdRegistryArgs['obj']['costToAddToAddress(address)uint64'] | NfdRegistryArgs['tuple']['costToAddToAddress(address)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.costToAddToAddress(params))
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `calcFuturePrice(uint64,uint64)uint64` ABI method.
     *
     * Calculates the future price based on the current price and the number of years.
     *
     * @param params The params for the smart contract call
     * @returns The call transaction
     */
    calcFuturePrice: (params: CallParams<NfdRegistryArgs['obj']['calcFuturePrice(uint64,uint64)uint64'] | NfdRegistryArgs['tuple']['calcFuturePrice(uint64,uint64)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      return this.appClient.createTransaction.call(NfdRegistryParamsFactory.calcFuturePrice(params))
    },

  }

  /**
   * Send calls to the current app
   */
  readonly send = {
    /**
     * Gets available update methods
     */
    update: {
      /**
       * Updates an existing instance of the NFDRegistry smart contract using the `updateApplication()void` ABI method.
       *
       * @param params The params for the smart contract call
       * @returns The update result
       */
      updateApplication: async (params: CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & AppClientCompilationParams & SendParams = {args: []}) => {
        const result = await this.appClient.send.update(NfdRegistryParamsFactory.update.updateApplication(params))
        return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['updateApplication()void'])}
      },

    },

    /**
     * Makes a clear_state call to an existing instance of the NFDRegistry smart contract.
     *
     * @param params The params for the bare (raw) call
     * @returns The clearState result
     */
    clearState: (params?: Expand<AppClientBareCallParams & SendParams>) => {
      return this.appClient.send.bare.clearState(params)
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `gas()void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    gas: async (params: CallParams<NfdRegistryArgs['obj']['gas()void'] | NfdRegistryArgs['tuple']['gas()void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.gas(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['gas()void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getPrice(string,address)(uint64,uint64,bool,bool,bool)` ABI method.
     *
    * Returns the price for a given NFD (single year), the max # of years allowed (Name for Display),
    and extra algo required to cover MBR when purchasing.

     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    getPrice: async (params: CallParams<NfdRegistryArgs['obj']['getPrice(string,address)(uint64,uint64,bool,bool,bool)'] | NfdRegistryArgs['tuple']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.getPrice(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['getPrice(string,address)(uint64,uint64,bool,bool,bool)'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    getConstraints: async (params: CallParams<NfdRegistryArgs['obj']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'] | NfdRegistryArgs['tuple']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC} = {args: []}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.getConstraints(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNfdMbrCost(string)uint64` ABI method.
     *
    * Returns the MBR amounts needed to MINT an nfd.
    This value needs to be added to purchase price in mintNfd call.
    getPrice() returns it though.

     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    getNfdMbrCost: async (params: CallParams<NfdRegistryArgs['obj']['getNfdMbrCost(string)uint64'] | NfdRegistryArgs['tuple']['getNfdMbrCost(string)uint64']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.getNfdMbrCost(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['getNfdMbrCost(string)uint64'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    getNfdLinkOnMintExtraMbrCost: async (params: CallParams<NfdRegistryArgs['obj']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'] | NfdRegistryArgs['tuple']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.getNfdLinkOnMintExtraMbrCost(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `mintNfd(pay,string,address,bool)uint64` ABI method.
     *
     * Mint an NFD (NFT) and create a new NFD instance.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    mintNfd: async (params: CallParams<NfdRegistryArgs['obj']['mintNfd(pay,string,address,bool)uint64'] | NfdRegistryArgs['tuple']['mintNfd(pay,string,address,bool)uint64']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.mintNfd(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['mintNfd(pay,string,address,bool)uint64'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `linkNfdAddress(string,uint64,address)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    linkNfdAddress: async (params: CallParams<NfdRegistryArgs['obj']['linkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['linkNfdAddress(string,uint64,address)void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.linkNfdAddress(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['linkNfdAddress(string,uint64,address)void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `unlinkNfdAddress(string,uint64,address)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    unlinkNfdAddress: async (params: CallParams<NfdRegistryArgs['obj']['unlinkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['unlinkNfdAddress(string,uint64,address)void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.unlinkNfdAddress(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['unlinkNfdAddress(string,uint64,address)void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `ownershipAssign(string,uint64)void` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    ownershipAssign: async (params: CallParams<NfdRegistryArgs['obj']['ownershipAssign(string,uint64)void'] | NfdRegistryArgs['tuple']['ownershipAssign(string,uint64)void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.ownershipAssign(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['ownershipAssign(string,uint64)void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `ownershipChanged(string,uint64,address,address)void` ABI method.
     *
    * This method is triggered when the ownership of an NFD (Non-Fungible Domain) changes.
    It is called by the NFD via the purchase method.  It can also be called by TxnLab admin for older 3.3
    NFDs when it detects purchased events for 3.3

     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    ownershipChanged: async (params: CallParams<NfdRegistryArgs['obj']['ownershipChanged(string,uint64,address,address)void'] | NfdRegistryArgs['tuple']['ownershipChanged(string,uint64,address,address)void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.ownershipChanged(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['ownershipChanged(string,uint64,address,address)void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `setAddressPrimaryNfd(string,uint64,address)void` ABI method.
     *
    * Makes the specified NFD the 'first' NFD in the reverse-address set so its the primary NFD for this address.
    The NFD must be valid, and the sender must be the address (or nfd owner if vault).  The NFD wouldn't already be
    in the reverse-lookup set if it wasn't already valid.

     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    setAddressPrimaryNfd: async (params: CallParams<NfdRegistryArgs['obj']['setAddressPrimaryNfd(string,uint64,address)void'] | NfdRegistryArgs['tuple']['setAddressPrimaryNfd(string,uint64,address)void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.setAddressPrimaryNfd(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['setAddressPrimaryNfd(string,uint64,address)void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `upgradeNfd(string)string` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    upgradeNfd: async (params: CallParams<NfdRegistryArgs['obj']['upgradeNfd(string)string'] | NfdRegistryArgs['tuple']['upgradeNfd(string)string']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.upgradeNfd(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['upgradeNfd(string)string'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `isValidNfdAppId(string,uint64)bool` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    isValidNfdAppId: async (params: CallParams<NfdRegistryArgs['obj']['isValidNfdAppId(string,uint64)bool'] | NfdRegistryArgs['tuple']['isValidNfdAppId(string,uint64)bool']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.isValidNfdAppId(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['isValidNfdAppId(string,uint64)bool'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getNameAppId(string)uint64` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    getNameAppId: async (params: CallParams<NfdRegistryArgs['obj']['getNameAppId(string)uint64'] | NfdRegistryArgs['tuple']['getNameAppId(string)uint64']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.getNameAppId(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['getNameAppId(string)uint64'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `getAddressAppIds(address)uint64[]` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    getAddressAppIds: async (params: CallParams<NfdRegistryArgs['obj']['getAddressAppIds(address)uint64[]'] | NfdRegistryArgs['tuple']['getAddressAppIds(address)uint64[]']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.getAddressAppIds(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['getAddressAppIds(address)uint64[]'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractInit(string,uint64,byte[])void` ABI method.
     *
     * Initializes the NFD contract bytecode into the registry
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    nfdContractInit: async (params: CallParams<NfdRegistryArgs['obj']['nfdContractInit(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractInit(string,uint64,byte[])void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.nfdContractInit(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['nfdContractInit(string,uint64,byte[])void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractLoad(string,uint64,byte[])void` ABI method.
     *
     * Loads contract data into the  box at the specified offset.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    nfdContractLoad: async (params: CallParams<NfdRegistryArgs['obj']['nfdContractLoad(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractLoad(string,uint64,byte[])void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.nfdContractLoad(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['nfdContractLoad(string,uint64,byte[])void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `nfdContractCommit(string)void` ABI method.
     *
     * Commit a new version of the contract.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    nfdContractCommit: async (params: CallParams<NfdRegistryArgs['obj']['nfdContractCommit(string)void'] | NfdRegistryArgs['tuple']['nfdContractCommit(string)void']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.nfdContractCommit(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['nfdContractCommit(string)void'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `usdInMicroAlgo(uint64)uint64` ABI method.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    usdInMicroAlgo: async (params: CallParams<NfdRegistryArgs['obj']['usdInMicroAlgo(uint64)uint64'] | NfdRegistryArgs['tuple']['usdInMicroAlgo(uint64)uint64']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.usdInMicroAlgo(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['usdInMicroAlgo(uint64)uint64'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `costToAddToAddress(address)uint64` ABI method.
     *
     * Returns the cost to add an NFD to the reverse-lookup data
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    costToAddToAddress: async (params: CallParams<NfdRegistryArgs['obj']['costToAddToAddress(address)uint64'] | NfdRegistryArgs['tuple']['costToAddToAddress(address)uint64']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.costToAddToAddress(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['costToAddToAddress(address)uint64'])}
    },

    /**
     * Makes a call to the NFDRegistry smart contract using the `calcFuturePrice(uint64,uint64)uint64` ABI method.
     *
     * Calculates the future price based on the current price and the number of years.
     *
     * @param params The params for the smart contract call
     * @returns The call result
     */
    calcFuturePrice: async (params: CallParams<NfdRegistryArgs['obj']['calcFuturePrice(uint64,uint64)uint64'] | NfdRegistryArgs['tuple']['calcFuturePrice(uint64,uint64)uint64']> & SendParams & {onComplete?: OnApplicationComplete.NoOpOC}) => {
      const result = await this.appClient.send.call(NfdRegistryParamsFactory.calcFuturePrice(params))
      return {...result, return: result.return as unknown as (undefined | NfdRegistryReturns['calcFuturePrice(uint64,uint64)uint64'])}
    },

  }

  /**
   * Clone this app client with different params
   *
   * @param params The params to use for the the cloned app client. Omit a param to keep the original value. Set a param to override the original value. Setting to undefined will clear the original value.
   * @returns A new app client with the altered params
   */
  public clone(params: CloneAppClientParams) {
    return new NfdRegistryClient(this.appClient.clone(params))
  }

  /**
   * Methods to access state for the current NFDRegistry app
   */
  state = {
    /**
     * Methods to access local state for the current NFDRegistry app
     */
    local: (address: string | Address) => {
      const encodedAddress = typeof address === 'string' ? address : encodeAddress(address.publicKey)
      return {
        /**
         * Get all current keyed values from local state
         */
        getAll: async (): Promise<Partial<Expand<LocalKeysState>>> => {
          const result = await this.appClient.state.local(encodedAddress).getAll()
          return {
          }
        },
        /**
         * Get values from the localState map in local state
         */
        localState: {
          /**
           * Get all current values of the localState map in local state
           */
          getMap: async (): Promise<Map<Uint8Array, Uint8Array>> => { return (await this.appClient.state.local(encodedAddress).getMap("localState")) as Map<Uint8Array, Uint8Array> },
          /**
           * Get a current value of the localState map by key from local state
           */
          value: async (key: Uint8Array | string): Promise<Uint8Array | undefined> => { return await this.appClient.state.local(encodedAddress).getMapValue("localState", key) as Uint8Array | undefined },
        },
      }
    },
    /**
     * Methods to access box state for the current NFDRegistry app
     */
    box: {
      /**
       * Get all current keyed values from box state
       */
      getAll: async (): Promise<Partial<Expand<BoxKeysState>>> => {
        const result = await this.appClient.state.box.getAll()
        return {
        }
      },
      /**
       * Get values from the boxes map in box state
       */
      boxes: {
        /**
         * Get all current values of the boxes map in box state
         */
        getMap: async (): Promise<Map<Uint8Array, Uint8Array>> => { return (await this.appClient.state.box.getMap("boxes")) as Map<Uint8Array, Uint8Array> },
        /**
         * Get a current value of the boxes map by key from box state
         */
        value: async (key: Uint8Array | string): Promise<Uint8Array | undefined> => { return await this.appClient.state.box.getMapValue("boxes", key) as Uint8Array | undefined },
      },
    },
  }

  public newGroup(): NfdRegistryComposer {
    const client = this
    const composer = this.algorand.newGroup()
    let promiseChain:Promise<unknown> = Promise.resolve()
    const resultMappers: Array<undefined | ((x: ABIReturn | undefined) => any)> = []
    return {
      /**
       * Add a gas()void method call against the NFDRegistry contract
       */
      gas(params: CallParams<NfdRegistryArgs['obj']['gas()void'] | NfdRegistryArgs['tuple']['gas()void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.gas(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a getPrice(string,address)(uint64,uint64,bool,bool,bool) method call against the NFDRegistry contract
       */
      getPrice(params: CallParams<NfdRegistryArgs['obj']['getPrice(string,address)(uint64,uint64,bool,bool,bool)'] | NfdRegistryArgs['tuple']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.getPrice(params)))
        resultMappers.push((v) => client.decodeReturnValue('getPrice(string,address)(uint64,uint64,bool,bool,bool)', v))
        return this
      },
      /**
       * Add a getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64) method call against the NFDRegistry contract
       */
      getConstraints(params: CallParams<NfdRegistryArgs['obj']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'] | NfdRegistryArgs['tuple']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.getConstraints(params)))
        resultMappers.push((v) => client.decodeReturnValue('getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)', v))
        return this
      },
      /**
       * Add a getNfdMbrCost(string)uint64 method call against the NFDRegistry contract
       */
      getNfdMbrCost(params: CallParams<NfdRegistryArgs['obj']['getNfdMbrCost(string)uint64'] | NfdRegistryArgs['tuple']['getNfdMbrCost(string)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.getNfdMbrCost(params)))
        resultMappers.push((v) => client.decodeReturnValue('getNfdMbrCost(string)uint64', v))
        return this
      },
      /**
       * Add a getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64) method call against the NFDRegistry contract
       */
      getNfdLinkOnMintExtraMbrCost(params: CallParams<NfdRegistryArgs['obj']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'] | NfdRegistryArgs['tuple']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.getNfdLinkOnMintExtraMbrCost(params)))
        resultMappers.push((v) => client.decodeReturnValue('getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)', v))
        return this
      },
      /**
       * Add a mintNfd(pay,string,address,bool)uint64 method call against the NFDRegistry contract
       */
      mintNfd(params: CallParams<NfdRegistryArgs['obj']['mintNfd(pay,string,address,bool)uint64'] | NfdRegistryArgs['tuple']['mintNfd(pay,string,address,bool)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.mintNfd(params)))
        resultMappers.push((v) => client.decodeReturnValue('mintNfd(pay,string,address,bool)uint64', v))
        return this
      },
      /**
       * Add a linkNfdAddress(string,uint64,address)void method call against the NFDRegistry contract
       */
      linkNfdAddress(params: CallParams<NfdRegistryArgs['obj']['linkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['linkNfdAddress(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.linkNfdAddress(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a unlinkNfdAddress(string,uint64,address)void method call against the NFDRegistry contract
       */
      unlinkNfdAddress(params: CallParams<NfdRegistryArgs['obj']['unlinkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['unlinkNfdAddress(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.unlinkNfdAddress(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a ownershipAssign(string,uint64)void method call against the NFDRegistry contract
       */
      ownershipAssign(params: CallParams<NfdRegistryArgs['obj']['ownershipAssign(string,uint64)void'] | NfdRegistryArgs['tuple']['ownershipAssign(string,uint64)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.ownershipAssign(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a ownershipChanged(string,uint64,address,address)void method call against the NFDRegistry contract
       */
      ownershipChanged(params: CallParams<NfdRegistryArgs['obj']['ownershipChanged(string,uint64,address,address)void'] | NfdRegistryArgs['tuple']['ownershipChanged(string,uint64,address,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.ownershipChanged(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a setAddressPrimaryNfd(string,uint64,address)void method call against the NFDRegistry contract
       */
      setAddressPrimaryNfd(params: CallParams<NfdRegistryArgs['obj']['setAddressPrimaryNfd(string,uint64,address)void'] | NfdRegistryArgs['tuple']['setAddressPrimaryNfd(string,uint64,address)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.setAddressPrimaryNfd(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a upgradeNfd(string)string method call against the NFDRegistry contract
       */
      upgradeNfd(params: CallParams<NfdRegistryArgs['obj']['upgradeNfd(string)string'] | NfdRegistryArgs['tuple']['upgradeNfd(string)string']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.upgradeNfd(params)))
        resultMappers.push((v) => client.decodeReturnValue('upgradeNfd(string)string', v))
        return this
      },
      /**
       * Add a isValidNfdAppId(string,uint64)bool method call against the NFDRegistry contract
       */
      isValidNfdAppId(params: CallParams<NfdRegistryArgs['obj']['isValidNfdAppId(string,uint64)bool'] | NfdRegistryArgs['tuple']['isValidNfdAppId(string,uint64)bool']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.isValidNfdAppId(params)))
        resultMappers.push((v) => client.decodeReturnValue('isValidNfdAppId(string,uint64)bool', v))
        return this
      },
      /**
       * Add a getNameAppId(string)uint64 method call against the NFDRegistry contract
       */
      getNameAppId(params: CallParams<NfdRegistryArgs['obj']['getNameAppId(string)uint64'] | NfdRegistryArgs['tuple']['getNameAppId(string)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.getNameAppId(params)))
        resultMappers.push((v) => client.decodeReturnValue('getNameAppId(string)uint64', v))
        return this
      },
      /**
       * Add a getAddressAppIds(address)uint64[] method call against the NFDRegistry contract
       */
      getAddressAppIds(params: CallParams<NfdRegistryArgs['obj']['getAddressAppIds(address)uint64[]'] | NfdRegistryArgs['tuple']['getAddressAppIds(address)uint64[]']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.getAddressAppIds(params)))
        resultMappers.push((v) => client.decodeReturnValue('getAddressAppIds(address)uint64[]', v))
        return this
      },
      /**
       * Add a nfdContractInit(string,uint64,byte[])void method call against the NFDRegistry contract
       */
      nfdContractInit(params: CallParams<NfdRegistryArgs['obj']['nfdContractInit(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractInit(string,uint64,byte[])void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.nfdContractInit(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a nfdContractLoad(string,uint64,byte[])void method call against the NFDRegistry contract
       */
      nfdContractLoad(params: CallParams<NfdRegistryArgs['obj']['nfdContractLoad(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractLoad(string,uint64,byte[])void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.nfdContractLoad(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a nfdContractCommit(string)void method call against the NFDRegistry contract
       */
      nfdContractCommit(params: CallParams<NfdRegistryArgs['obj']['nfdContractCommit(string)void'] | NfdRegistryArgs['tuple']['nfdContractCommit(string)void']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.nfdContractCommit(params)))
        resultMappers.push(undefined)
        return this
      },
      /**
       * Add a usdInMicroAlgo(uint64)uint64 method call against the NFDRegistry contract
       */
      usdInMicroAlgo(params: CallParams<NfdRegistryArgs['obj']['usdInMicroAlgo(uint64)uint64'] | NfdRegistryArgs['tuple']['usdInMicroAlgo(uint64)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.usdInMicroAlgo(params)))
        resultMappers.push((v) => client.decodeReturnValue('usdInMicroAlgo(uint64)uint64', v))
        return this
      },
      /**
       * Add a costToAddToAddress(address)uint64 method call against the NFDRegistry contract
       */
      costToAddToAddress(params: CallParams<NfdRegistryArgs['obj']['costToAddToAddress(address)uint64'] | NfdRegistryArgs['tuple']['costToAddToAddress(address)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.costToAddToAddress(params)))
        resultMappers.push((v) => client.decodeReturnValue('costToAddToAddress(address)uint64', v))
        return this
      },
      /**
       * Add a calcFuturePrice(uint64,uint64)uint64 method call against the NFDRegistry contract
       */
      calcFuturePrice(params: CallParams<NfdRegistryArgs['obj']['calcFuturePrice(uint64,uint64)uint64'] | NfdRegistryArgs['tuple']['calcFuturePrice(uint64,uint64)uint64']> & {onComplete?: OnApplicationComplete.NoOpOC}) {
        promiseChain = promiseChain.then(async () => composer.addAppCallMethodCall(await client.params.calcFuturePrice(params)))
        resultMappers.push((v) => client.decodeReturnValue('calcFuturePrice(uint64,uint64)uint64', v))
        return this
      },
      get update() {
        return {
          updateApplication: (params: CallParams<NfdRegistryArgs['obj']['updateApplication()void'] | NfdRegistryArgs['tuple']['updateApplication()void']> & AppClientCompilationParams) => {
            promiseChain = promiseChain.then(async () => composer.addAppUpdateMethodCall(await client.params.update.updateApplication(params)))
            resultMappers.push(undefined)
            return this
          },
        }
      },
      /**
       * Add a clear state call to the NFDRegistry contract
       */
      clearState(params: AppClientBareCallParams) {
        promiseChain = promiseChain.then(() => composer.addAppCall(client.params.clearState(params)))
        return this
      },
      addTransaction(txn: Transaction, signer?: TransactionSigner) {
        promiseChain = promiseChain.then(() => composer.addTransaction(txn, signer))
        return this
      },
      async composer() {
        await promiseChain
        return composer
      },
      async simulate(options?: SimulateOptions) {
        await promiseChain
        const result = await (!options ? composer.simulate() : composer.simulate(options))
        return {
          ...result,
          returns: result.returns?.map((val, i) => resultMappers[i] !== undefined ? resultMappers[i]!(val) : val.returnValue)
        }
      },
      async send(params?: SendParams) {
        await promiseChain
        const result = await composer.send(params)
        return {
          ...result,
          returns: result.returns?.map((val, i) => resultMappers[i] !== undefined ? resultMappers[i]!(val) : val.returnValue)
        }
      }
    } as unknown as NfdRegistryComposer
  }
}
export type NfdRegistryComposer<TReturns extends [...any[]] = []> = {
  /**
   * Calls the gas()void ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  gas(params?: CallParams<NfdRegistryArgs['obj']['gas()void'] | NfdRegistryArgs['tuple']['gas()void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['gas()void'] | undefined]>

  /**
   * Calls the getPrice(string,address)(uint64,uint64,bool,bool,bool) ABI method.
   *
  * Returns the price for a given NFD (single year), the max # of years allowed (Name for Display),
  and extra algo required to cover MBR when purchasing.

   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  getPrice(params?: CallParams<NfdRegistryArgs['obj']['getPrice(string,address)(uint64,uint64,bool,bool,bool)'] | NfdRegistryArgs['tuple']['getPrice(string,address)(uint64,uint64,bool,bool,bool)']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['getPrice(string,address)(uint64,uint64,bool,bool,bool)'] | undefined]>

  /**
   * Calls the getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64) ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  getConstraints(params?: CallParams<NfdRegistryArgs['obj']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'] | NfdRegistryArgs['tuple']['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['getConstraints()(uint64,uint64,uint64,address,uint64,uint64,uint64)'] | undefined]>

  /**
   * Calls the getNfdMbrCost(string)uint64 ABI method.
   *
  * Returns the MBR amounts needed to MINT an nfd.
  This value needs to be added to purchase price in mintNfd call.
  getPrice() returns it though.

   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  getNfdMbrCost(params?: CallParams<NfdRegistryArgs['obj']['getNfdMbrCost(string)uint64'] | NfdRegistryArgs['tuple']['getNfdMbrCost(string)uint64']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['getNfdMbrCost(string)uint64'] | undefined]>

  /**
   * Calls the getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64) ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  getNfdLinkOnMintExtraMbrCost(params?: CallParams<NfdRegistryArgs['obj']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'] | NfdRegistryArgs['tuple']['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['getNfdLinkOnMintExtraMbrCost(address)(uint64,uint64)'] | undefined]>

  /**
   * Calls the mintNfd(pay,string,address,bool)uint64 ABI method.
   *
   * Mint an NFD (NFT) and create a new NFD instance.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  mintNfd(params?: CallParams<NfdRegistryArgs['obj']['mintNfd(pay,string,address,bool)uint64'] | NfdRegistryArgs['tuple']['mintNfd(pay,string,address,bool)uint64']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['mintNfd(pay,string,address,bool)uint64'] | undefined]>

  /**
   * Calls the linkNfdAddress(string,uint64,address)void ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  linkNfdAddress(params?: CallParams<NfdRegistryArgs['obj']['linkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['linkNfdAddress(string,uint64,address)void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['linkNfdAddress(string,uint64,address)void'] | undefined]>

  /**
   * Calls the unlinkNfdAddress(string,uint64,address)void ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  unlinkNfdAddress(params?: CallParams<NfdRegistryArgs['obj']['unlinkNfdAddress(string,uint64,address)void'] | NfdRegistryArgs['tuple']['unlinkNfdAddress(string,uint64,address)void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['unlinkNfdAddress(string,uint64,address)void'] | undefined]>

  /**
   * Calls the ownershipAssign(string,uint64)void ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  ownershipAssign(params?: CallParams<NfdRegistryArgs['obj']['ownershipAssign(string,uint64)void'] | NfdRegistryArgs['tuple']['ownershipAssign(string,uint64)void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['ownershipAssign(string,uint64)void'] | undefined]>

  /**
   * Calls the ownershipChanged(string,uint64,address,address)void ABI method.
   *
  * This method is triggered when the ownership of an NFD (Non-Fungible Domain) changes.
  It is called by the NFD via the purchase method.  It can also be called by TxnLab admin for older 3.3
  NFDs when it detects purchased events for 3.3

   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  ownershipChanged(params?: CallParams<NfdRegistryArgs['obj']['ownershipChanged(string,uint64,address,address)void'] | NfdRegistryArgs['tuple']['ownershipChanged(string,uint64,address,address)void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['ownershipChanged(string,uint64,address,address)void'] | undefined]>

  /**
   * Calls the setAddressPrimaryNfd(string,uint64,address)void ABI method.
   *
  * Makes the specified NFD the 'first' NFD in the reverse-address set so its the primary NFD for this address.
  The NFD must be valid, and the sender must be the address (or nfd owner if vault).  The NFD wouldn't already be
  in the reverse-lookup set if it wasn't already valid.

   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  setAddressPrimaryNfd(params?: CallParams<NfdRegistryArgs['obj']['setAddressPrimaryNfd(string,uint64,address)void'] | NfdRegistryArgs['tuple']['setAddressPrimaryNfd(string,uint64,address)void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['setAddressPrimaryNfd(string,uint64,address)void'] | undefined]>

  /**
   * Calls the upgradeNfd(string)string ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  upgradeNfd(params?: CallParams<NfdRegistryArgs['obj']['upgradeNfd(string)string'] | NfdRegistryArgs['tuple']['upgradeNfd(string)string']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['upgradeNfd(string)string'] | undefined]>

  /**
   * Calls the isValidNfdAppId(string,uint64)bool ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  isValidNfdAppId(params?: CallParams<NfdRegistryArgs['obj']['isValidNfdAppId(string,uint64)bool'] | NfdRegistryArgs['tuple']['isValidNfdAppId(string,uint64)bool']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['isValidNfdAppId(string,uint64)bool'] | undefined]>

  /**
   * Calls the getNameAppId(string)uint64 ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  getNameAppId(params?: CallParams<NfdRegistryArgs['obj']['getNameAppId(string)uint64'] | NfdRegistryArgs['tuple']['getNameAppId(string)uint64']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['getNameAppId(string)uint64'] | undefined]>

  /**
   * Calls the getAddressAppIds(address)uint64[] ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  getAddressAppIds(params?: CallParams<NfdRegistryArgs['obj']['getAddressAppIds(address)uint64[]'] | NfdRegistryArgs['tuple']['getAddressAppIds(address)uint64[]']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['getAddressAppIds(address)uint64[]'] | undefined]>

  /**
   * Calls the nfdContractInit(string,uint64,byte[])void ABI method.
   *
   * Initializes the NFD contract bytecode into the registry
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  nfdContractInit(params?: CallParams<NfdRegistryArgs['obj']['nfdContractInit(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractInit(string,uint64,byte[])void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['nfdContractInit(string,uint64,byte[])void'] | undefined]>

  /**
   * Calls the nfdContractLoad(string,uint64,byte[])void ABI method.
   *
   * Loads contract data into the  box at the specified offset.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  nfdContractLoad(params?: CallParams<NfdRegistryArgs['obj']['nfdContractLoad(string,uint64,byte[])void'] | NfdRegistryArgs['tuple']['nfdContractLoad(string,uint64,byte[])void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['nfdContractLoad(string,uint64,byte[])void'] | undefined]>

  /**
   * Calls the nfdContractCommit(string)void ABI method.
   *
   * Commit a new version of the contract.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  nfdContractCommit(params?: CallParams<NfdRegistryArgs['obj']['nfdContractCommit(string)void'] | NfdRegistryArgs['tuple']['nfdContractCommit(string)void']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['nfdContractCommit(string)void'] | undefined]>

  /**
   * Calls the usdInMicroAlgo(uint64)uint64 ABI method.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  usdInMicroAlgo(params?: CallParams<NfdRegistryArgs['obj']['usdInMicroAlgo(uint64)uint64'] | NfdRegistryArgs['tuple']['usdInMicroAlgo(uint64)uint64']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['usdInMicroAlgo(uint64)uint64'] | undefined]>

  /**
   * Calls the costToAddToAddress(address)uint64 ABI method.
   *
   * Returns the cost to add an NFD to the reverse-lookup data
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  costToAddToAddress(params?: CallParams<NfdRegistryArgs['obj']['costToAddToAddress(address)uint64'] | NfdRegistryArgs['tuple']['costToAddToAddress(address)uint64']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['costToAddToAddress(address)uint64'] | undefined]>

  /**
   * Calls the calcFuturePrice(uint64,uint64)uint64 ABI method.
   *
   * Calculates the future price based on the current price and the number of years.
   *
   * @param args The arguments for the contract call
   * @param params Any additional parameters for the call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  calcFuturePrice(params?: CallParams<NfdRegistryArgs['obj']['calcFuturePrice(uint64,uint64)uint64'] | NfdRegistryArgs['tuple']['calcFuturePrice(uint64,uint64)uint64']>): NfdRegistryComposer<[...TReturns, NfdRegistryReturns['calcFuturePrice(uint64,uint64)uint64'] | undefined]>

  /**
   * Makes a clear_state call to an existing instance of the NFDRegistry smart contract.
   *
   * @param args The arguments for the bare call
   * @returns The typed transaction composer so you can fluently chain multiple calls or call execute to execute all queued up transactions
   */
  clearState(params?: AppClientBareCallParams): NfdRegistryComposer<[...TReturns, undefined]>

  /**
   * Adds a transaction to the composer
   *
   * @param txn A transaction to add to the transaction group
   * @param signer The optional signer to use when signing this transaction.
   */
  addTransaction(txn: Transaction, signer?: TransactionSigner): NfdRegistryComposer<TReturns>
  /**
   * Returns the underlying AtomicTransactionComposer instance
   */
  composer(): Promise<TransactionComposer>
  /**
   * Simulates the transaction group and returns the result
   */
  simulate(): Promise<NfdRegistryComposerResults<TReturns> & { simulateResponse: SimulateResponse }>
  simulate(options: SkipSignaturesSimulateOptions): Promise<NfdRegistryComposerResults<TReturns> & { simulateResponse: SimulateResponse }>
  simulate(options: RawSimulateOptions): Promise<NfdRegistryComposerResults<TReturns> & { simulateResponse: SimulateResponse }>
  /**
   * Sends the transaction group to the network and returns the results
   */
  send(params?: SendParams): Promise<NfdRegistryComposerResults<TReturns>>
}
export type NfdRegistryComposerResults<TReturns extends [...any[]]> = Expand<SendAtomicTransactionComposerResults & {
  returns: TReturns
}>

